import enLocale from 'element-ui/lib/locale/lang/en'
import enUS from 'vxe-table/lib/locale/lang/en-US'

//英文
export default {
  ...enLocale,
  ...enUS,

  base: {
    error: {
      400: 'Error in requesting data, please try again later!',
      401: 'Authorization exception or login expired, please log in again!',
      404: 'No related data found!',
      500: 'Internal server error, please contact the administrator!',
      503: 'Service unavailable, please try again later!'
    },
    title: 'Green Solutions Cloud Platform',
    prompt_title: 'Kind Reminder',
    develop: 'Under development...',
    success: 'Operation successful!',
    more: 'More',
    upload: {
      error: 'Upload failed!'
    },
    zh: 'Chinese',
    en: 'English'
  },

  login: {
    account: 'Account Login',
    username_placeholder: 'Please enter your login email',
    username_label: 'Email',
    username_empty: 'Please enter your login email',
    username_type: 'Please enter a valid email address',
    password_label: 'Password',
    password_placeholder: 'Please enter your login password',
    password_empty: 'Please enter your login password',
    login_in: 'Login Now',
    code: 'Code Login',
    code_label: 'V-Code',
    code_empty: 'Please enter the verification code',
    code_placeholder: 'Enter the verification code',
    msg_empty: 'Send code',
    msg_sending: 'Retry in {value}s',
    clause_text: 'Read and agree to',
    clause_title: '《Privacy Policy》',
    remember: 'Save Pwd',
    forgot: 'Forgot Pwd?',
    register_prefix: 'No account?',
    register: 'Register Now',
    wechat: 'WeChat',
    qq: 'QQ',
    facebook: 'Facebook',
    twitter: 'Twitter',
    password_old: 'Old Pass',
    password_old_placeholder: 'Please enter your old password',
    password_old_empty: 'Please enter your old password',
    password_new: 'New Pass',
    password_new_placeholder: 'Please enter your new password',
    password_new_empty: 'Please enter your new password',
    password_confirm: 'Con. Pwd',
    password_confirm_placeholder: 'Please enter your confirm password',
    password_confirm_empty: 'Please enter your confirm password',
    password_confirm_error: 'Confirmation password does not match the new password',
    login_forgot: 'Reset Password',
    zipCode_label: 'Postal Code',
    zipCode_empty: 'Please enter the postal code',
    zipCode_placeholder: 'Enter the postal code',
    phone_label: 'Phone Number',
    phone_placeholder: 'Please enter your phone number',
    company_label: 'Name',
    company_placeholder: 'Please enter your company name',
    company_empty: 'Please enter your company name',
    licence_label: 'License',
    licence_placeholder: 'Please enter your business license number',
    licence_empty: 'Please enter your business license number',
    address_placeholder: 'Please enter your business address',
    address_empty: 'Please enter your business address',
    invite_label: 'Inv. Code',
    invite_placeholder: 'Please enter the invitation code',
    invite_empty: 'Please enter the invitation code',
    continents_label: 'Continent',
    continents_placeholder: 'Select a continent',
    continents_empty: 'Please select a continent',
    country_label: 'Country',
    country_placeholder: 'Select a country',
    country_empty: 'Please select a country',
    province_label: 'Province',
    province_placeholder: 'Please enter the province',
    province_empty: 'Please enter the province',
    city_label: 'City',
    city_placeholder: 'Please enter the city',
    city_empty: 'Please enter the city',
    region_label: 'Region',
    region_placeholder: 'Please enter the region',
    region_empty: 'Please enter the region',
    street_label: 'Street',
    street_placeholder: 'Please enter the street',
    street_empty: 'Please enter the street',
    detail_label: 'Full Address(CN)',
    detail_placeholder: 'Please enter the detailed address of Chinese',
    detail_empty: 'Please enter the detailed address',
    pcrDetail_label: 'Prov./St./City(CN)',
    pcrDetail_placeholder: 'Please enter Province/State/City of Chinese',
    pcrDetail_empty: 'Please enter Province/State/City',
    enPcrDetail_label: 'Prov./St./City(EN)',
    enPcrDetail_placeholder: 'Please enter Province/State/City of English',
    enDetail_label: 'Full Address(EN)',
    enDetail_placeholder: 'Please enter the detailed address of English',
    customerCode_label: 'Customer Code',
    customerCode_placeholder: 'Please enter the customer code'
  },

  policies: {
    back: 'Back to Login',
    title: 'Privacy Policy Explanation',
    zh_title: 'Chinese Content',
    us_title: 'English Content',
    save: 'Save'
  },

  forgot:{
    back: 'Back',
    title: 'Retrieve Password',
    success: 'Password reset successful!'
  },

  register: {
    back: 'Back to Login',
    step1_title: 'Type Selection',
    step2_title: 'Basic Infor',
    step3_title: 'Company Infor',
    step4_title: 'Successful',
    step1_user1: 'Dealer Registration',
    step1_user2: 'Installer Registration',
    step1_user3: 'Owner Registration',
    btn_next: 'Next Step',
    btn_pre: 'Back to Previous Step',
    btn_register: 'Register Now',
    company_title: 'New Company Registration',
    invite_title: 'Invitation Code Registration',
    success: 'Congratulations, registration successful!',
    success_btn: 'Login Now',
    password_confirm_error: 'Confirmation password does not match the login password'
  },

  work: {
    menu_expand: 'Expand Menu',
    menu_collapse: 'Collapse Menu',
    user_info: 'Edit Profile',
    user_logout: 'Logout',
    logout_prompt: 'Are you sure you want to logout?'
  },

  info: {
    title: 'Personal Information',
    tabs: {
      info: 'Basic Infor',
      company: 'Company Infor',
      security: 'Security Settings',
      agreement: 'Service Agreement'
    },
    info: {
      username: 'Account/Email:',
      mailbox: 'Alarm Push Email:',
      mailbox_placeholder: 'Please select the alarm push level',
      mailbox_empty: 'Close',
      zipCode: 'Postal Code:',
      phone: 'Phone Number:',
      btn: 'Edit Now'
    },
    company: {
      status: 'Status:',
      status_0: 'Approved',
      status_1: 'Pending Review',
      status_2: 'Review Failed',
      code: 'Invitation Code:',
      copy: 'Copy',
      copy_success: 'Copy Successful!',
      copy_error: 'Copy Failed',
      name: 'Company Name:',
      licence: 'Business License:',
      address: 'Business Address:',
      continents: 'Continent/Country:',
      region: 'Region:',
      street: 'Street:',
      detail: 'Detailed Address:',
      pcrDetail: 'Province/State/City:',
      approveReason: 'Reason for Review:',
      editBtn: 'Edit Now'
    },
    security: {
      editbtn: 'Edit',
      password: 'Password Settings:',
      password_describe: 'Password set for the account',
      password_title: 'Change Password',
      username: 'Change Account:',
      username_describe: 'Bound Email',
      username_title: 'Change Account',
      bind: 'Bind Now',
      unbind: 'Unbind',
      wechat: 'Bind WeChat:',
      wechat_describe: 'Bound WeChat',
      qq: 'Bind QQ:',
      qq_describe: 'Bound QQ',
      facebook: 'Bind Facebook:',
      facebook_describe: 'Bound Facebook',
      twitter: 'Bind Twitter:',
      twitter_describe: 'Bound Twitter',
      cancel: 'Account Cancellation:',
      cancel_describe: 'Cancel the current account, erase all data',
      cancelBtn: 'Cancel Account',
      username_label: 'Email',
      code_label: 'Code',
      cancel_prompt: 'Cancelling your account will erase all your identity information, account information, and all usage records, including but not limited to history, alarm, and transaction records, and cannot be recovered. Do you wish to continue?'
    }
  },

  dialog:{
    define: 'Define',
    cancel: 'Cancel'
  },

  table: {
    seq: 'Serial',
    refresh: 'Refresh',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    delete_prompt: 'Are you sure you want to delete this data?',
    select_empty: 'Please select data!',
    subset_add: 'Add Sublevel',
    status: 'Status',
    status_0: 'Normal',
    status_1: 'Deleted',
    status_2: 'Disabled',
    status_placeholder: 'Please select status',
    sortNum: 'Order',
    sortNum_placeholder: 'Please enter order number',
    remark: 'Remark',
    remark_placeholder: 'Please enter remark',
    createTime: 'Creation Time',
    updateTime: 'Update Time',
    action: 'Action',
    query: 'Query',
    reset: 'Reset',
    detail: 'Detail',
    input_placeholder: 'Please enter',
    export: 'Export'
  },

  menu: {
    zhName: 'Chinese Name',
    zhName_placeholder: 'Please enter Chinese name',
    zhName_empty: 'Please enter Chinese name',
    usName: 'English Name',
    usName_placeholder: 'Please enter English name',
    usName_empty: 'Please enter English name',
    type: 'Level',
    perms: 'Auth',
    perms_placeholder: 'Please enter the permission identifier',
    component: 'Web Address',
    component_placeholder: 'Please enter web address',
    detail: {
      title: 'Menu Maintenance'
    }
  },

  role: {
    left_title: 'Assigned Roles',
    right_title: 'Included Permissions',
    name: 'Chinese Name',
    name_empty: 'Please enter chinese name',
    name_placeholder: 'Please Enter chinese name',
    enName: 'English Name',
    enName_empty: 'Please enter english name',
    enName_placeholder: 'Please enter english name',
    code: 'Role Code',
    code_empty: 'Please enter role code',
    code_placeholder: 'Enter role code',
    detail: {
      title: 'Role Maintenance'
    },
    save: 'Save'
  },

  user: {
    username: 'Email',
    username_placeholder: 'Please enter email',
    country: 'Country',
    country_placeholder: 'Select country',
    role: 'Role',
    role_placeholder: 'Select role',
    phone: 'Phone',
    zipCode: 'Postal Code',
    company: 'Company',
    company_title: 'Company Details',
    companys: {
      name: 'Name',
      status: 'Status',
      licence: 'License',
      country: 'Country',
      pcrDetail: 'Prov./St./City',
      detail: 'Address',
      approveReason: 'Review Rsn.'
    },
    enable: 'Enable',
    stop: 'Stop',
    delete: 'Delete',
    add_title: 'Add User',
    companyId: 'Company',
    company_empty: 'Please select the company',
    companyId_placeholder: 'Please select the company',
    lastLoginDate: 'LastLoginDate',
    deleteInfo: 'Are you sure you want to delete the 【{user}】 user?？',
    dealer: 'Associated Dealers'
  },

  company: {
    name: 'Name',
    name_placeholder: 'Please enter the company name',
    approveStatus: 'Status',
    approveStatus_placeholder: 'Please select the approval status',
    approveStatus_0: 'Approved',
    approveStatus_1: 'Pending Review',
    approveStatus_2: 'Not Approved',
    licence: 'License',
    licence_placeholder: 'Please enter the business license',
    continents: 'Continents',
    country: 'Country',
    country_placeholder: 'Please select a country',
    pcrDetail: 'Province/State/City',
    detail: 'Detailed Address',
    approveReason: 'Approve Reason',
    approveReason_placeholder: 'Please enter the review reason',
    examine: 'Approve',
    examine_title: 'Review',
    audit: 'Pending Review',
    confirm_button: 'Approve',
    cancel_button: 'Disapprove',
    status_prompt: 'Has the company information been approved?',
    user_btn: 'User',
    user_title: 'User List',
    details: {
      title: 'Company Detail'
    }
  },

  warn: {
    names: 'Name',
    names_placeholder: 'Please enter the name of the alarm',
    name: 'Chinese Name',
    name_empty: 'Please enter the Chinese name of the alarm',
    name_placeholder: 'Please enter the Chinese name of the alarm',
    enName: 'English Name',
    enName_empty: 'Please enter the English name of the alarm',
    enName_placeholder: 'Please enter the English name of the alarm',
    code: 'Code',
    code_empty: 'Please enter the warning code',
    code_placeholder: 'Please enter the warning code',
    deviceType: 'Device Type',
    deviceType_empty: 'Please select a device type',
    deviceType_placeholder: 'Please select a device type',
    grade: 'Level',
    grade_placeholder: 'Please select the warning level',
    grade_empty: 'Please select the warning level',
    grade_0: 'Alarm',
    grade_1: 'Fault',
    reason: 'Reason',
    reason_placeholder: 'Please enter the reason for the alarm',
    advice: 'Advice',
    advice_placeholder: 'Please enter action advice',
    detail: {
      title: 'Warning Maintenance'
    },
    info: {
      title: 'Alarm Details',
      total: 'Alarms Total',
      unhandle: 'Unhandle Num.',
      handle: 'Handle Num.',
      define: 'Handle',
      download: 'Download',
      export: 'Export'
    }
  },

  dic: {
    name: 'Chinese Name',
    name_empty: 'Please enter the Chinese name',
    name_placeholder: 'Please enter the Chinese name',
    usName: 'English Name',
    usName_empty: 'Please enter the English name',
    usName_placeholder: 'Please enter the English name',
    code: 'Value Code',
    code_placeholder: 'Please enter the value code',
    value: 'Value',
    value_placeholder: 'Please enter the value',
    detail: {
      'title': 'Dictionary Maintenance'
    }
  },

  product: {
    name: 'Product Name',
    name_empty: 'Please enter the product name',
    name_placeholder: 'Please enter the product name',
    deviceType: 'Device Type',
    deviceType_empty: 'Please select a device type',
    deviceType_placeholder: 'Please select a device type',
    detail: {
      title: 'Product Maintenance'
    }
  },

  guide: {
    v2g: 'V2G',
    switchbox: 'Switchbox',
    inverter: 'Inverter',
    collector: 'Dongle',
    battery: 'Battery',
    solar: 'Solar',
    charge: 'EV Charging Station',
    count: {
      total: 'Total',
      online: 'Online',
      warn: 'Warn',
      fault: 'Fault',
      offline: 'Offline',
      pending: 'Unregistered'
    },
    station: {
      list_day_buy: 'Total Day Elec. Buy',
      list_day_sell: 'Total Day Elec. Sold',
      list_month_buy: 'Total Month Elec. Buy',
      list_month_sell: 'Total Month Elec. Sold',
      one_day_buy: 'Day Elec. Buy',
      one_day_sell: 'Day Elec. Sold',
      one_month_buy: 'Month Elec. Buy',
      one_month_sell: 'Month Elec. Sold',
      weather: {
        week: {
          0: 'Sunday',
          1: 'Monday',
          2: 'Tuesday',
          3: 'Wednesday',
          4: 'Thursday',
          5: 'Friday',
          6: 'Saturday'
        },
        time: 'Updated On'
      },
      count: {
        day: 'Day',
        month: 'Month',
        all: 'Total',
        all_generation_power: 'Total power generation',
        all_use_power: 'Total power Use',
        self_generation_sale: 'Amount of self ele. sales',
        self_generation_use: 'Amount of self ele. use',
        buy_amount: 'Electricity purchase amount',
        sell_amount: 'Electricity sales amount',
        payable_amount: 'Total amount payable',
        paid_amount: 'Total paid in amount',
        save_amount: 'Total savings',
        coal_savings: 'Coal savings',
        equivalent_green_plant: 'Equivalent green',
        co2_reduction: 'CO2 reduction'
      },
      energy: {
        pv_title: 'PV',
        pv_content: 'Daily Generation:',
        battery_title: 'Battery',
        battery_content: 'Daily Chg/Dis:',
        grid_title: 'Grid',
        grid_content: 'Daily Buy/Sell:',
        charge_title: 'Charging Pile',
        charge_content: 'Daily Usage:',
        load_title: 'Load',
        load_content: 'Daily Usage:',
        ups_title: 'UPS',
        ups_content: 'Daily Usage:',
        eps_title: 'Backup Power',
        power_title: 'Power Source'
      },
      power: {
        pv: 'PV Power',
        grid: 'Grid Power',
        battery: 'Battery Power',
        charge: 'Charging Pile Power',
        load: 'Load Power'
      },
      list: {
        title: 'Power Station List',
        add: 'Add Power Station',
        table: {
          name: 'Name',
          name_placeholder: 'Please enter the name of the power station',
          owner: 'Owner',
          owner_placeholder: 'Please enter owner',
          dealer: 'Dealer',
          dealer_placeholder: 'Please enter dealer',
          installer: 'Installer',
          installer_placeholder: 'Please enter installer',
          id: 'ID',
          id_placeholder: 'Please enter ID',
          sn: 'SN',
          sn_placeholder: 'Please enter SN',
          country: 'Country',
          country_placeholder: 'Please select country',
          postCode: 'ZipCode',
          postCode_placeholder: 'Please enter postal code',
          createTime: 'CreateTime',
          createTime_range: 'To',
          createTime_start: 'Start Time',
          createTime_end: 'End Time',
          firstOnTime: 'FirstOnTime',
          firstOnTime_range: 'To',
          firstOnTime_start: 'Start Time',
          firstOnTime_end: 'End Time'
        }
      },
      map: {
        title: 'Power Station Map'
      },
      add: {
        title: 'Add Power Station',
        step1_title: 'Basic Information',
        step2_title: 'Electricity Pricing Settings',
        name: 'Name',
        name_empty: 'Please enter the name of the power station',
        name_placeholder: 'Please enter the name of the power station',
        siteType: 'Type',
        siteType_empty: 'Please select the type of power station',
        siteType_placeholder: 'Please select the type of power station',
        volume: 'Total Capacity',
        volume_placeholder: 'Please enter estimated total capacity',
        zipCode: 'Postal Code',
        zipCode_placeholder: 'Please enter postal code',
        gridType: 'Grid Conn. Type',
        gridType_placeholder: 'Please select grid connection type',
        gmt: 'Gmt',
        gmt_placeholder: 'Please select time zone',
        gridTime: 'Grid Conn. Time',
        gridTime_placeholder: 'Please select grid connection time',
        address: 'Address',
        address_placeholder: 'Please select location address',
        detail: 'Detail Addrs',
        detail_placeholder: 'Please enter detailed address',
        next_btn: 'Next Step',
        pre_btn: 'Previous Step',
        price_company: 'Electricity Company',
        price_company_placeholder: 'Please enter the name of the electricity company',
        price_day_range: 'To',
        price_day_start: 'Start Date',
        price_day_end: 'End Date',
        price_time_range: 'To',
        price_time_start: 'Start Time',
        price_time_end: 'End Time',
        price_price: 'Electricity Price',
        price_work_title: 'Weekday Electricity Price:',
        price_nonwork_title: 'Non-Weekday Electricity Price:',
        cost: 'Cost',
        cost_placeholder: 'Please enter cost',
        date_error: 'Date cannot be empty',
        time_error: 'Time cannot be empty',
        price_error: 'Price cannot be empty',
        date_repeat: 'Repeated date range',
        time_repeat: 'Repeated time range',
        time_continuous: 'Discontinuous time interval',
        country_zh: 'Country Chinese',
        country_en: 'Country English',
        country_zh_placeholder: 'Please enter the country name in Chinese',
        country_en_placeholder: 'Please enter the country name in English',
        detail_zh: 'Detail Chinese',
        detail_en: 'Detail English',
        detail_zh_placeholder: 'Please enter the detail in Chinese',
        detail_en_placeholder: 'Please enter the detail in English',
        choose: 'Choose',
        x: 'Longitude',
        x_placeholder: 'Please enter longitude',
        y: 'Latitude',
        y_placeholder: 'Please enter latitude'
      },
      address: {
        title: 'Location Address Selection',
        select: 'Selected Address:',
        prompt: 'Click on the location on the map to select the location',
        x: 'Longitude',
        y: 'Dimension',
        query: 'Query'
      },
      detail: {
        base_title: 'Basic Information',
        base_add: 'Add Equipment',
        base_name: 'Name',
        base_siteType: 'Type',
        base_volume: 'Total Capacity',
        base_status: 'Status',
        base_owner: 'Owner',
        base_gmt: 'Gmt',
        base_address: 'Address',
        add: {
          title: 'Add Equipment to Power Station',
          sn: 'SN',
          sn_placeholder: 'Please enter the SN',
          name: 'Equipment Name',
          model: 'Equipment Model',
          system_name: 'System Name：',
          system_name_placeholder: 'Please enter the system name',
          installer_name: 'Installer：',
          installer_name_placeholder: 'Please select installer',
          id_name: 'ID',
          id_name_placeholder: 'Please enter the device ID',
          concatType_name: 'ConcatType：',
          concatType_name_placeholder: 'Please select concat yype',
          concatType_0: 'Single',
          concatType_1: 'Parallel',
          deviceIds: 'Please select the device that needs to be added',
          search: 'Select',
          activeBind: 'Activate/Bind'
        },
        guide: {
          title: 'Overview',
          panel_battery_1: 'charge',
          panel_battery_2: 'discharge',
          pv: 'PV',
          grid: 'Grid',
          battery: 'Battery',
          charge: 'Charging Pile',
          load: 'Load',
          soc: 'SOC',
          alternator: 'Generator',
          buy: 'Electricity Purchased',
          sell: 'Electricity Sold',
          card_generate_power: 'Daily Generation',
          card_usage_power: 'Daily Usage',
          card_buy_power: 'Selling Income',
          card_sell_power: 'Purchasing Expenses',
          count_time_placeholder: 'Please select',
          count_date: 'Day',
          count_month: 'Month',
          count_year: 'Year',
          count_count: 'Total',
          download: 'Download',
          start_time_range: 'To',
          start_time_placeholder: 'Start Date',
          end_time_placeholder: 'End Date',
          export_a: 'Station'
        },
        setup: {
          title: 'SetUp',
          power_alarm_min: 'Min Power Alarm',
          power_alarm_min_placeholder: 'Please enter the minimum power consumption alarm',
          power_alarm_max: 'Max Power Alarm',
          power_alarm_max_placeholder: 'Please enter the maximum power consumption alarm',
          power_alarm_prompt_placeholder: 'Please enter a prompt'
        },
        analysis: {
          title: 'Analysis'
        },
        layout: {
          title: 'Layout',
          time_placeholder: 'Please select date',
          play: 'Play',
          pause: 'Stop',
          edit: 'Edit Layout',
          plus: 'Add',
          delete: 'Delete',
          delete_prompt: 'Are you sure you want to delete the selected component?',
          edit1: 'Edit',
          bind: 'Bind',
          unbind: 'UnBind',
          back: 'Back',
          save: 'Save',
          data: {
            title: 'Add Component',
            row: 'Row',
            column: 'Column',
            direction: 'Direction',
            direction0: 'Direction',
            direction1: 'Transverse',
            dip: 'Dip Angle(°)',
            position: 'Azimuth(°)',
            btn: 'Define'
          },
          binding: {
            title: 'Bind Device',
            search_placeholder: 'Please enter device SN'
          }
        },
        infor: {
          title: 'Information',
          save: 'Save'
        },
        device: {
          title: 'Device',
          name: 'Name',
          main: 'Set Master-Slave Device',
          masterOrSlave: 'Master-Slave',
          masterOrSlave_0: 'None',
          masterOrSlave_1: 'Master',
          masterOrSlave_2: 'Slave',
          main_error: 'No device information to modify',
          main_master_error: 'There can only be one main device',
          out: 'Exit',
          out_prompt: 'Are you sure you want to exit the power station for this device?',
          out_system_prompt: 'Are you sure you want to delete the system?',
          table_sn: 'SN',
          table_update_time: 'UpdateTime',
          table_run_time: 'RunTime',
          table_inverter_rated: 'Rated',
          table_inverter_real: 'RealTime',
          table_inverter_day_quantity: 'Daily',
          table_inverter_count_quantity: 'Cumulative',
          table_collector_strength: 'Signal Strength',
          table_battery_model: 'Model'
        },
        warn: {
          title: 'Warning',
          table_grade: 'Grade',
          table_device: 'Device',
          table_sn: 'Device SN',
          table_content: 'Content',
          table_code: 'Code',
          table_time: 'Time',
          table_handle: 'Handling Method'
        },
        energy: {
          title: 'Energy Saving',
          dispatch: 'Scheduling',
          sell: 'Selling to Grid',
          buy: 'Buying from Grid',
          save: 'Save',
          sell_power: ' Max Selling Power',
          buy_power: ' Max Buying Power',
          sell_power_placeholder: 'Please enter the max selling power',
          buy_power_placeholder: 'Please enter the max buying power',
          tab_1: 'Cost',
          tab_2: 'Predict',
          time_placeholder: 'Please select',
          date: 'Day',
          month: 'Month',
          year: 'Year',
          count: 'Total'
        }
      }
    },
    device: {
      id: 'ID',
      sn: 'SN',
      mode: 'By Station',
      dealer: 'Dealer',
      dealer_placeholder: 'Please enter dealer',
      installer: 'Installer',
      station: 'Station',
      version: 'Version',
      country: 'Country',
      zipCode: 'ZipCode',
      remark: 'Note',
      remark_placeholder: 'Please enter remark',
      advise: 'Advise',
      advise_placeholder: 'Please enter advise',
      restart: 'Restart',
      first_online_time: 'FirstTime',
      join_station_time: 'JoinTime',
      leave_station_time: 'LeaveTime',
      offline_time: 'OfflineTime',
      offline_num: 'OfflineNum',
      duration: 'Online/Offline Duration',
      voltage: 'Voltage(V)',
      soc: 'SOC(%)',
      upgrade_time: 'UpgradeTime',
      empty: 'No device selected, please select a device from the list on the left',
      add: {
        btn: 'Add Device',
        title: 'Device Addition',
        value_placeholder: 'Please enter SN, Multiple separated by English commas',
        value_empty: 'Please enter SN'
      },
      crumb: 'Device Detail',
      filterSN: 'Enter SN or Device Id for filtering',
      more: 'More Conditions',
      battery: {
        count_day_kwh: 'Daily power consumption',
        count_month_kwh: 'Monthly power consumption',
        count_day_charge: 'Daily power charge',
        count_month_charge: 'Monthly power charge',
        model: 'Model',
        sections: 'Battery Cell',
        voltage_high: 'Max Voltage',
        voltage_low: 'Min Voltage',
        voltage_now: 'Current Voltage',
        quantity_now: 'Current Power',
        parallel_mode_unit_num: 'Parallel Module Units',
        battery: 'Battery',
        detail: {
          voltage: 'Voltage',
          temperature: 'Temperature',
          defaultCurrent: 'Current',
          power: 'Power',
          info: 'General Information',
          relay: 'Relay',
          version: 'Version',
          bmsVersion: 'BMS Version',
          modulesNum: 'Modules Num',
          cellNum: 'Number of Series',
          rateCapacity: 'Rated Capacity',
          soc: 'SOC',
          chargePower: 'Charging Power',
          dischargePower: 'Discharge Power',
          incrChargeNum: 'Cumulative Charge Capacity',
          strongImpact: 'Strong Impact',
          incrDischargeNum: 'Cumulative Discharge Capacity',
          allVoltage: 'System Voltage',
          systemVoltage: 'System Voltage',
          outputVoltage: 'Output Voltage',
          totalIndividualVoltage: 'Total Individual Voltage',
          hv1: 'HV1',
          hv2: 'HV2',
          moduleNumber: 'Module Number',
          IndividualDifference: 'System Individual Difference',
          reqChargeVoltage: 'Requested Charge Voltage',
          commonIncrVoltage: 'Cumulative Cell Voltage',
          avgCommonVoltage: 'Average Cell Voltage',
          maxCommonVoltage: 'Maximum Cell Voltage',
          minCommonVoltage: 'Minimum Cell Voltage',
          voltageDifferent: 'Cell Voltage Difference',
          current: 'Current',
          nowDefaultCurrent: 'Current',
          reqChargeCurrent: 'Requested Charge Current',
          reqDischargeCurrent: 'Requested Discharge Current',
          rateChargeCurrent: 'Rated Charge Current',
          rateDischargeCurrent: 'Rated Discharge Current',
          maxChargingCurrent: 'Max Charging Current',
          maxDisChargingCurrent: 'Max DisCharging Current',
          effectTemperatureSensation: 'Num',
          maxCommonTemperature: 'Cell Max',
          minCommonTemperature: 'Cell Min',
          temperatureDifferent: 'Max Difference',
          commonTemperature: 'Cell Temperature {data}',
          heatElementTemperature: 'Heater Temperature {data}',
          maxMonomerTemperature: 'Max Monomer Temperature',
          minMonomerTemperature: 'Min Monomer Temperature',
          relayTemperature: 'Relay Temperature {data}',
          relayTableFunction: 'Function',
          relayTableInstruct: 'Instruct',
          relayTableState: 'State',
          relayFunction: 'Relay {data} Function',
          relayStatus: 'Relay {data} Status',
          heatRelayStatus: 'Heating Relay {data} Status',
          heatRelayContactStatus: 'Heating Relay {data} Contact Status',
          relay_1: 'Main Positive',
          relay_2: 'Main Negative',
          relay_3: 'Heat',
          relay_4: 'PreCharge',
          relay_5: 'Wiring Status',
          module: 'Module Information',
          balanced: 'Balance Status',
          balanceVoltage: 'Balancing Voltage {data}',
          monomer: 'Cell Information',
          commonVoltage: 'Cell Voltage {data}',
          arguments: 'Parameter Settings',
          argumentsAll: 'Batch Parameter Settings',
          debugging: 'Debug',
          debug: {
            title: 'Remote Debugging',
            input: 'Please enter the command',
            send: 'Send',
            success: 'Link successfully established',
            fail: 'Link establishment failed'
          },
          upgrade: 'Upgrade',
          export_name: 'Export Data',
          export_range: 'To',
          export_start: 'Start Time',
          export_end: 'End Time',
          export_btn: 'Export',
          export_a: 'Battery',
          chart: {
            time: 'Time',
            day: 'Day',
            month: 'Month',
            year: 'Year',
            total: 'Total',
            current: 'Current',
            soc: 'SOC',
            temperature: 'Temperature',
            voltage: 'Voltage',
            voltages: 'Voltages',
            name: 'Battery Statistics Chart',
            title: 'Select Parameters',
            type_1: 'Battery voltage',
            type_2: 'Battery current',
            type_3: 'Battery power',
            type_4: 'Daily charging volume',
            type_5: 'Accumulated charging capacity',
            type_6: 'Daily discharge capacity',
            type_7: 'Accumulated discharge capacity',
            type_8: 'BMS battery voltage',
            type_9: 'BMS battery current',
            type_10: 'Battery SOC',
            type_11: 'Battery SOH',
            type_12: 'Overrelease of SOC',
            type_13: 'Strong charging SOC',
            type_14: 'Battery charging current limiting',
            type_15: 'Battery discharge current limiting',
            max: 'Select up to 4 units',
            export_emty: 'Please select the exported data'
          },
          relayFunctionValue: {
            'none': '',
            '0': 'None',
            '1': 'PreCharge',
            '2': 'Refrigeration',
            '3': 'Heating',
            '4': 'Total Positive',
            '5': 'Total Negative',
            '6': 'Fault Light',
            '7': 'Running Light',
            '8': 'Power Light',
            '9': 'Charging',
            '10': 'Discharge',
            '11': 'DCDC',
            '12': 'Custom 1',
            '13': 'Custom 2'
          },
          relayStatusValue: {
            'none': '',
            '0': 'Discon',
            '1': 'Closed',
            '2': 'NA',
            '3': 'NA',
            '4': 'NA',
            '5': 'NA',
            '6': 'NA',
            '7': 'NA',
            '8': 'NA',
            '9': 'NA',
            '10': 'NA',
            '11': 'NA',
            '12': 'NA',
            '13': 'NA'
          },
          balanceVoltageValue: {
            'none': '',
            '0': 'Off',
            '1': 'On'
          },
          mainPositiveRelay: {
            'none': '',
            '0': 'Discon',
            '1': 'Close',
            '2': 'NA',
            '3': 'NA',
            '4': 'NA',
            '5': 'NA',
            '6': 'NA',
            '7': 'NA',
            '8': 'NA',
            '9': 'NA',
            '10': 'NA',
            '11': 'NA',
            '12': 'NA',
            '13': 'NA'
          },
          strongImpactValue: {
            'none': '',
            '0': 'NO',
            '1': 'YES'
          },
          alarm: {
            btn: 'Alarm',
            title: 'Alarm Log',
            name: 'Warning Name',
            name_placeholder: 'Enter warning name',
            code: 'Warning Code',
            code_placeholder: 'Enter warning code'
          }
        },
        modules: {
          voltage: 'Individual Voltage',
          voltageChart: 'Individual Voltage Statistics Chart',
          temperature: 'Temp{data}'
        }
      },
      inverter: {
        count_day_generation: 'Day Power Gen.',
        count_day_use: 'Day Power Use',
        count_day_buy: 'Day Power Buy',
        count_day_sale: 'Day Power Sale',
        preview_real_time: 'Real Power',
        preview_day: 'Daily Full Hours',
        preview_alarm: 'Alarm',
        preview_environment: 'Internal Env.',
        preview_environment_max: 'Up to 105°C',
        preview_version: 'Version',
        preview_type: 'Type',
        preview_plant: 'Plant',
        preview_belongFactory: 'Inverter Manufacturer',
        belongFactory: {
          'none': '',
          1: 'H12',
          2: 'HX12',
          4: 'HH15'
        },
        detail: {
          system_title: 'System Info',
          system_code: 'Inverter Code',
          system_state: 'Inverter work status',
          system_rated_power: 'Inverter power rating',
          system_model: 'Inverter model',
          system_firm: 'Inverter Manufacturer',
          system_battery_firm: 'Battery Manufacturer',
          system_meter_firm: 'Electricity Meter Manufacturer',
          system_network_state: 'Networking status',
          system_collector_sn: 'Collector SN',
          version_title: 'Version information',
          version_dsp_main: 'Primary DSP version number',
          version_dsp_fit: 'Secondary DSP version number',
          version_cpld: 'CPLD version number',
          version_arm: 'ARM version number',
          generation_title: 'Generation Data',
          generation_table1_title1: 'DC',
          generation_table1_title2: 'Voltage(V)',
          generation_table1_title3: 'Current(A)',
          generation_table1_title4: 'Power(W)',
          generation_table2_title1: 'AC',
          generation_table2_title2: 'Voltage(V)',
          generation_table2_title3: 'Current(A)',
          generation_table2_title4: 'Power(W)',
          generation_time: 'Power generation time',
          generation_day_quantity: 'Eelectricity generated day',
          generation_all_quantity: 'Total electricity generation',
          generation_back_up_power: 'Back-Up total active power',
          generation_factor_power: 'Factor',
          generation_inverter_all_power: 'Inverter total active power',
          generation_inverter_r_power: 'Inverter R Phase active power',
          generation_inverter_s_power: 'Inverter S Phase active power',
          generation_inverter_t_power: 'Inverter T Phase active power',
          generation_normalize_power: 'Normalization',
          generation_day_hours: 'Full hours day',
          generation_dc_divergence: 'DC dispersion rate',
          generation_power: 'Power generation',
          grid_title: 'Power Grid',
          grid_day_sell: 'Grid sell power today',
          grid_all_sell: 'Total grid sell power',
          grid_day_buy: 'Grid buy power today',
          grid_all_buy: 'Total grid buy power',
          grid_voltage_pbus: 'PBUS voltage',
          grid_voltage_nbus: 'NBUS voltage',
          grid_voltage_rs: 'RS grid line voltage',
          grid_voltage_st: 'ST grid line voltage',
          grid_voltage_tr: 'TR grid line voltage',
          grid_voltage_r: 'R grid phase voltage',
          grid_voltage_s: 'S grid phase voltage',
          grid_voltage_t: 'T grid phase voltage',
          grid_current_r: 'R grid phase current',
          grid_current_s: 'S grid phase current',
          grid_current_t: 'T grid phase current',
          grid_power_all: 'Grid total active power',
          grid_power_r: 'Grid R phase active power',
          grid_power_s: 'Grid S phase active power',
          grid_power_t: 'Grid T phase active power',
          grid_load_power_all: 'Grid total load active power',
          grid_load_power_r: 'Grid R phase Load Active Power',
          grid_load_power_s: 'Grid S phase Load Active Power',
          grid_load_power_t: 'Grid T phase Load Active Power',
          grid_rate: 'Grid frequency',
          use_title: 'Electricity',
          use_day_load: 'Load Power consumption today',
          use_all_load: 'Total load power consumption',
          meter_title: 'Ammeter Data',
          meter_comm_status: 'Electric meter status',
          meter_voltage_r: 'Electric meter R voltage',
          meter_voltage_s: 'Electric meter S voltage',
          meter_voltage_t: 'Electric meter T voltage',
          meter_current_all: 'Electric meter total voltage',
          meter_current_r: 'Electric meter R current',
          meter_current_s: 'Electric meter S current',
          meter_current_t: 'Electric meter T current',
          meter_power_all: 'Electric meter total active power',
          meter_power_r: 'Electric meter R active power',
          meter_power_s: 'Electric meter S active power',
          meter_power_t: 'Electric meter T active power',
          battery_title: 'Battery Data',
          battery_capacity: 'Battery capacity',
          battery_voltage: 'Battery voltage',
          battery_current: 'Battery current',
          battery_power: 'Battery power',
          battery_soc: 'Battery SOC',
          battery_soh: 'Battery SOH',
          battery_day_charge: 'Battery today charge power',
          battery_all_charge: 'Battery total charge power',
          battery_day_discharge: 'Battery today discharge power',
          battery_all_discharge: 'Battery total discharge power',
          bms_title: 'BMS data',
          bms_comm_status: 'BMS communication status',
          bms_software_version: 'BMS software version',
          bms_hardware_version: 'BMS hardware version',
          bms_main_temperature: 'BMS master control temperature',
          bms_voltage_charge_max: 'Highest charge voltage',
          bms_voltage_discharge_min: 'Lowest discharge voltage',
          bms_current_charge_max: 'Highest charge current',
          bms_current_discharge_max: 'Highest discharge current',
          bms_voltage_monomer_max: 'Highest single voltage',
          bms_voltage_monomer_min: 'Lowest single voltage',
          bms_temperature_monomer_max: 'Highest single temperature',
          bms_temperature_monomer_min: 'Lowest single temperature',
          bms_voltage_monomer_max_id: 'Highest single voltage ID',
          bms_voltage_monomer_min_id: 'Lowest single voltage ID',
          bms_temperature_monomer_max_id: 'Highest single temperature ID',
          bms_temperature_monomer_min_id: 'Lowest single temperature ID',
          bms_charge_enable: 'Charge enable flag',
          bms_discharge_enable: 'Discharge enable flag',
          bms_charge_forced: 'Strong charge flag',
          bms_status: 'Battery status',
          bms_warn_code: 'BMS alarm code',
          bms_fault_code: 'BMS fault code',
          bms_protect_code: 'BMS protection code',
          ev_title: 'EV Data',
          ev_v2gs_device: 'V2GS access device',
          ev_v2gs_fault: 'V2GS fault code',
          ev_connection_status: 'EV connection status',
          ev_all_electricity: 'Total EV charge',
          ev_voltage_max: 'Maximum EV voltage',
          ev_current_max: 'EV maximum current',
          ev_full_soc: 'EV full charge SOC',
          ev_demand_voltage: 'EV demand voltage',
          ev_demand_current: 'EV demand current',
          temperature_title: 'Temperature',
          temperature_environment: 'Ambient temperature',
          temperature_radiator: 'Radiator temperature',
          temperature_inv_r: 'INV module R temperature',
          temperature_inv_s: 'INV module S temperature',
          temperature_inv_t: 'INV module T temperature',
          other_title: 'Other',
          other_real_time: 'Inverter real-time time',
          other_485_agreement: '485 protocol',
          other_485_addr: '485 address setting',
          other_485_baud: '485 baud rate setting',
          other_485_2_addr: '485_2 address settings',
          other_485_2_baud: '485_2 baud rate setting',
          export_a: 'Inverter',
          chart: {
            name: 'Inverter Statistics Chart'
          }
        },
        inteless: {
          profile_title: 'Profile',
          profile_sn: 'SN',
          profile_power: 'Rated Power',
          profile_type: 'Type',
          profile_status: 'Run status',
          profile_model: 'Model',
          profile_sw_ver: 'SW Ver.',
          profile_gateway: 'Gateway',
          profile_plant: 'Plant',
          profile_installer: 'Installer',
          output_title: 'Output',
          output_serial: 'serial number',
          output_power: 'Rated output power',
          output_voltage: 'Model PV rated voltage',
          output_current: 'Rated charging current of model PV',
          output_time: 'Inverter time',
          output_software_version1: 'Software version 1',
          output_software_version2: 'Software version 2',
          output_hardware_version1: 'Hardware version 1',
          output_hardware_version2: 'Hardware version 2',
          output_bms_version1: 'BMS version 1',
          output_bms_version2: 'BMS version 2',
          output_radiator_temperature: 'PV radiator temperature',
          output_heat_sink: 'Temperature of inverter heat sink',
          output_transformer_temperature: 'Transformer temperature',
          output_positive_busbar_voltage: 'Positive busbar voltage',
          output_negative_busbar_voltage: 'Negative busbar voltage',
          output_machine: 'Current state of the machine',
          output_l1_voltage: 'L1 Voltage',
          output_l1_current: 'L1 Current',
          output_l2_voltage: 'L2 Voltage',
          output_l2_current: 'L2 Current',
          output_external_temperature: 'External Temperature',
          output_minor_version: 'Minor Version',
          output_rs485_address: 'RS485 Address',
          output_total_voltage: 'Total bus voltage',
          input_title: 'Input',
          input_pv1_voltage: 'PV1 input voltage',
          input_pv1_current: 'PV1 input current',
          input_pv1_power: 'PV1 charging power',
          input_pv2_voltage: 'PV2 input voltage',
          input_pv2_current: 'PV2 input current',
          input_pv2_power: 'PV2 charging power',
          input_pv_current: 'PV charging current',
          input_pv_cumulative: 'PV cumulative power generation',
          input_pv_power: 'PPV',
          battery_title: 'Battery',
          battery_voltage: 'Battery voltage',
          battery_current: 'Battery current',
          battery_power: 'Battery charging and discharging power',
          battery_soc: 'Battery level SOC',
          battery_status: 'Battery charging status',
          battery_type: 'Battery type',
          battery_charging_same_day: 'Ampere-hours of battery charging on the same day',
          battery_discharge_same_day: 'Battery discharge ampere hours on the same day',
          battery_charging_ampere_hours: 'Accumulated battery charging ampere hours',
          battery_discharge_ampere_hours: 'Accumulated discharge ampere hours of battery',
          battery_soh: 'SOH',
          battery_rated_capacity: 'Battery rated capacity',
          battery_remain_capacity: 'Battery remain capacity',
          battery_cycles: 'Number of battery cycles',
          battery_bms_voltage: 'BMS Voltage',
          battery_bms_current: 'BMS Current',
          battery_bms_temp: 'BMS Temp',
          battery_bms_charge_voltage: 'BMS charge voltage',
          battery_bms_charge_current: 'BMS Charge current limit',
          battery_bms_discharge_current: 'BMS Discharge current limit',
          battery_alarms1: 'Alarms 1',
          battery_alarms2: 'Alarms 2',
          battery_protection1: 'Protection 1',
          battery_protection2: 'Protection 2',
          battery_bms_protocol: 'BMS protocol',
          battery_ch_total_rate: 'Total charging capacity',
          battery_dis_total_rate: 'Total discharge capacity',
          grid_title: 'Grid',
          grid_l1_voltage: 'L1 mains voltage',
          grid_l1_current: 'L1 mains current',
          grid_l1_power: 'L1 mains active power',
          grid_l2_voltage: 'L2 mains voltage',
          grid_l2_current: 'L2 mains current',
          grid_l2_power: 'L2 mains active power',
          grid_frequency: 'Mains frequency',
          grid_charging_hours: 'Charging hours on the same day of mains electricity',
          grid_l1_tv_power: 'L1 City TV in Power',
          grid_l2_tv_power: 'L2 City TV in power',
          grid_charging_current: 'Mains charging current',
          grid_grid_same_day: 'Grid connected electricity on the same day',
          grid_accumulated_capacity: 'Accumulated charging capacity of mains electricity',
          grid_electricity_purchased: 'Electricity purchased on the same day',
          grid_accumulated_purchased: 'Accumulated purchased electricity',
          grid_accumulated_grid: 'Accumulated grid connected power',
          grid_charging_power: 'Mains charging power',
          grid_a_power_push: 'CT Power A Push',
          grid_b_power_push: 'CT Power B Push',
          grid_total_power: 'Total power of the power grid',
          load_title: 'Load',
          load_l1_voltage: 'L1 load voltage',
          load_l1_current: 'L1 load current',
          load_l1_power: 'L1 load active power',
          load_l2_voltage: 'L2 load voltage',
          load_l2_current: 'L2 load current',
          load_l2_power: 'L2 load active power',
          load_l1_rate: 'L1 load rate',
          load_l2_rate: 'L2 load rate',
          load_l1_apparent_power: 'L1 load apparent power',
          load_l2_apparent_power: 'L2 load apparent power',
          load_frequency: 'output frequency',
          load_electricity_consumption: 'Electricity consumption on the day of load',
          load_accumulated_power: 'Accumulated power consumption of load',
          load_total_power: 'Total active power of load',
          load_total_apparent: 'Total apparent power of load'
        },
        sosen: {
          profile_title: 'Profile',
          profile_sn: 'SN',
          profile_power: 'Rated Power',
          profile_type: 'Type',
          profile_status: 'Run status',
          profile_model: 'Model',
          profile_sw_ver: 'SW Ver.',
          profile_gateway: 'Gateway',
          profile_plant: 'Plant',
          profile_installer: 'Installer',
          output_title: 'Output',
          output_system_state: 'System State',
          output_system_state_list: {
            'none': '',
            0: 'Standby',
            1: 'Charging',
            2: 'Discharge',
            3: 'Fault',
            4: 'Upgrade status',
            5: 'Unavailable',
            6: 'Locked'
          },
          output_inv_state: 'INV State',
          output_inv_state_list: {
            'none': '',
            '0': 'Shutdown',
            '1': 'Grid connected standby',
            '2': 'Off grid standby',
            '3': 'Grid connected operation',
            '4': 'Off grid operation',
            '5': ' Fault',
            '6': 'Bypass operation'
          },
          output_inv_volt_l1: 'INV Volt L1',
          output_inv_curr_l1: 'INV Curr L1',
          output_inv_p_l1: 'INV P-L1',
          output_inv_volt_l2: 'INV Volt L2',
          output_inv_curr_l2: 'INV Curr L2',
          output_inv_p_l2: 'INV P-L2',
          output_inv_freq: 'INV Freq',
          output_operation_time: 'Operation Time',
          input_title: 'Input',
          input_pv1_volt: 'PV1 Volt',
          input_pv1_curr: 'PV1 Curr',
          input_pv1_power: 'PV1 Power',
          input_pv2_volt: 'PV2 Volt',
          input_pv2_curr: 'PV2 Curr',
          input_pv2_power: 'PV2 Power',
          input_pv3_volt: 'PV3 Volt',
          input_pv3_curr: 'PV3 Curr',
          input_pv3_power: 'PV3 Power',
          input_pv_power: 'PV Total Power',
          input_pv_today: 'PV E-Today',
          input_pv_total: 'PV E-Total',
          battery_title: 'Battery',
          battery_bms_state: 'BMS State',
          battery_bms_state_list: {
            '0': 'Idle',
            '1': 'Charging',
            '2': 'Discharge',
            '3': 'Prohibit charging',
            '4': 'Prohibit discharge',
            '5': 'Prohibit charging and discharging'
          },
          battery_bms_volt: 'BMS Volt',
          battery_bms_curr: 'BMS Curr',
          battery_bat_power: 'BAT Power',
          battery_soc: 'SOC',
          battery_soh: 'SOH',
          battery_bat_temp: 'BAT Temp',
          battery_ch_max_volt: 'Ch Max Volt',
          battery_disch_min_volt: 'Disch Min Volt',
          battery_ch_max_curr: 'Ch Max Curr',
          battery_disch_max_curr: 'Disch Max Curr',
          grid_title: 'Grid',
          grid_freq: 'Grid Freq',
          grid_volt_l1: 'Grid Volt L1',
          grid_curr_l1: 'Grid Curr L1',
          grid_p_l1: 'Grid P-L1',
          grid_volt_l2: 'Grid Volt L2',
          grid_curr_l2: 'Grid Curr L2',
          grid_p_l2: 'Grid P-L2',
          grid_import_today: 'Import E-Today',
          grid_import_total: 'Import E-Total',
          grid_export_today: 'Export E-Today',
          grid_export_total: 'Export E-Total',
          load_title: 'Load',
          load_freq: 'Load Freq',
          load_volt_l1: 'Load Volt L1',
          load_curr_l1: 'Load Curr L1',
          load_p_l1: 'Load P-L1',
          load_volt_l2: 'Load Volt L2',
          load_curr_l2: 'Load Curr L2',
          load_p_l2: 'Load P-L2',
          load_e_today: 'Load E-Today',
          load_e_total: 'Load E-Total',
          load_p_total: 'Home Load P-Total'
        }
      },
      switchbox: {
        count_day_generation: 'Day Power Gen.',
        count_day_use: 'Day Power Use',
        count_day_buy: 'Day Power Buy',
        count_day_sale: 'Day Power Sale',
        switchbox_status_text: 'Box Status',
        switchbox_status: {
          'none': '',
          '0': 'Offline',
          '1': 'Online',
          '2': 'Alarm',
          '3': 'Unregistered',
          '4': 'Fault'
        },
        network_status_text: 'Grid Status',
        network_status: {
          'none': '',
          '0': 'Offline',
          '1': 'Online'
        },
        update_time: 'Update Time',
        detail: {
          export_a: 'box',
          chart: {
            name: 'Intelligent Distribution Box Statistics Chart'
          },
          version_title: 'Version Info',
          version_version: 'Version',
          version_sn: 'SN',
          version_factory: 'Factory',
          version_hardware_version: 'Hardware Version',
          version_firmware_version: 'Firmware Version',
          version_model: 'Model',
          version_version_update_time: 'Version Update Time'
        }
      },
      v2g: {
        count_day_generation: 'Day Power Gen.',
        count_day_use: 'Day Power Use',
        count_day_buy: 'Day Power Buy',
        count_day_sale: 'Day Power Sale',
        count_grt_day: 'Day Capacity',
        count_grt_month: 'Month Capacity',
        count_grt_year: 'Year Capacity',
        count_grt_total: 'Total Capacity',
        status: 'Current State',
        statusValue: {
          '1': 'Charge Now',
          '2': 'DisCharge Now',
          '3': 'Appointment Charging',
          '4': 'Appointment DisCharge',
          '5': 'Grid Dispatch Charge',
          '6': 'Grid Dispatch DisCharge',
          '7': 'Electric Appointment Charging',
          '8': 'Electric Appointment DisCharge'
        },
        soc: 'Current SOC',
        power: 'Current Power',
        workStatus: 'Work Status',
        workStatusValue: {
          '0': 'Idle without gun inserted',
          '1': 'Idle gun inserted',
          '2': 'Idle fault',
          '3': 'Charging waiting',
          '4': 'Charging',
          '5': 'Charging pause',
          '6': 'Charging completed',
          '7': 'Charging malfunction'
        },
        expChargeTime: 'Appointment',
        expPower: 'Current Power',
        ap: 'A',
        bp: 'B',
        cp: 'C',
        apVoltage: 'A Voltage',
        apCurrent: 'A Current',
        apPower: 'A Power',
        bpVoltage: 'B Voltage',
        bpCurrent: 'B Current',
        bpPower: 'B Power',
        cpVoltage: 'B Voltage',
        cpCurrent: 'B Current',
        cpPower: 'B Power',
        detail: {
          export_a: 'V2G',
          chart: {
            name: 'V2G Statistics Chart'
          },
          version_title: 'Version Info',
          version_software_version: 'Software Version',
          version_protocol_version: 'Protocol Version',
          version_sn: 'SN',
          version_model: 'Model',
          version_hardware_version: 'Hardware Version',
          version_version_update_time: 'Version Update Time',
          charge_title: 'Immediate Charge Info',
          charge_power: 'Limit Power',
          charge_soc: 'Limit SOC',
          charge_feedNetwork: 'Feed Network',
          discharge_title: 'Immediate DisCharge Info',
          discharge_power: 'Limit Power',
          discharge_soc: 'Limit SOC',
          discharge_feedNetwork: 'Feed Network',
          make_charge_title: 'Make Charge Info',
          make_charge_power: 'Limit Power',
          make_charge_soc: 'Limit SOC',
          make_charge_feedNetwork: 'Feed Network',
          make_discharge_title: 'Make DisCharge Info',
          make_discharge_time_title: 'Make Charge And DisCharge Time',
          make_discharge_power: 'Limit Power',
          make_discharge_soc: 'Limit SOC',
          make_discharge_feedNetwork: 'Feed Network',
          dispatch_title: 'Power Grid Dispatch Info',
          dispatch_time: 'Dispatch Time',
          dispatch_feedNetwork: 'Feed Network',
          optimize_title: 'Electricity Tariff Optimization Info',
          optimize_power: 'Limit Power',
          optimize_soc: 'Limit SOC',
          optimize_feedNetwork: 'Feed Network',
          off_title: 'Off grid Info',
          off_soc: 'Limit SOC',
          off_discharge: 'Electro-Discharge',
          device_title: 'Equipment Infor',
          device_current: 'Single Charge Capacity',
          device_quantity: 'Electrical Amperage',
          device_cp: 'CP Status',
          device_equipment: 'Equipment No',
          device_version: 'Version',
          device_server: 'Server Link',
          device_currCpStatusValue: {
            '0': 'CP12 not connected',
            '1': 'CP12 PWM',
            '2': 'CP9 is connected',
            '3': 'CP9 PWM',
            '4': 'CP6 charging',
            '5': 'CP6 PWM',
            '6': 'Error'
          },
          feedNetwork: {
            '0': 'Feed Network',
            '1': 'Non Feed Network'
          },
          offlineDisNow: {
            '0': 'Not Discharge',
            '1': 'Discharge'
          }
        }
      },
      charge: {
        detail: {
          chart: {
            name: 'EV Charging Station Statistics Chart'
          }
        }
      },
      collector: {
        preview_sn: 'SN',
        preview_key: 'Key',
        preview_plant: 'Plant',
        preview_customer: 'Customer',
        preview_owner: 'Owner',
        preview_mcu_ver: 'Main MCU ver.',
        preview_hw_ver: 'HW Ver.',
        preview_model: 'Model',
        preview_ssid: 'Router SSID',
        preview_router_address: 'Router MAC Address',
        preview_wifi_address: 'Wi-Fi MAC Address',
        preview_ble_address: 'BLE MAC Address'
      },
      made: {
        title: 'Parameter Settings'
      },
      madeAll: {
        title: 'Batch Parameter Settings'
      }
    },
    manage: {
      entered: 'Join Power Station',
      notEntered: 'Not Join Power Station',
      notonline: 'Not Configure Network',
      online: 'Configure Network',
      statistics: 'Device Statistics',
      template: 'Import Template Download',
      table: {
        serial: 'Product Serial Number',
        deviceType: 'Type',
        deviceType_placeholder: 'Please select device type',
        owner: 'Owner',
        installer: 'Installer',
        installer_placeholder: 'Please enter installer',
        dealer: 'Dealer',
        dealer_placeholder: 'Please enter dealer',
        country: 'Country',
        country_placeholder: 'Please select country',
        installTime: 'InstallTime',
        installTime_range: 'To',
        installTime_start: 'Start Time',
        installTime_end: 'End Time',
        import: 'Import',
        createTime: 'CreateTime',
        firstOnTime: 'FirstOnTime',
        onOffTime: 'OnOffTime',
        importTime: 'ImportTime',
        importTime_range: 'To',
        importTime_start: 'Start Time',
        importTime_end: 'End Time',
        deliveryTime: 'DeliveryTime',
        dataSourceType: 'DataSource'
      },
      installer: {
        title: 'Batch setting of installers',
        installer_placeholder: 'Search for installer',
        installer_select_empty: 'Please select installer'
      }
    },
    made: {
      save: 'Set Up',
      reset: 'Reset',
      input: 'Please enter',
      select: 'Please select',
      pitch: 'Pitch',
      num: 'Num',
      min: 'Min',
      dialog_title: 'Confirm Settings',
      id: 'ID',
      sn: 'SN',
      empty: 'There is no content to set',
      import: 'Import',
      battery: {
        title: 'Battery Settings',
        control: 'Control',
        control_volume: 'SysResCap',
        control_relay: 'Relay{data} Forced Ctrl',
        control_restore: 'Fac Restore',
        control_erase: 'Clear History',
        control_default: 'DefaultConfig',
        control_reset: 'Reset',
        bms_reset: 'BMS Reset',
        system: 'System',
        system_address: 'AddrNum',
        system_bmu: 'BMUNum',
        system_slave_battery: 'NumOfSB',
        system_slave_warm: 'STempSNum',
        system_nominal_volume: 'NSCap',
        system_all_volume: 'TSCap',
        system_slave_data_cycle: 'RSDataCycle',
        system_slave_response_timeout: 'SRTimeOut',
        system_battery_rated_voltage: 'RTVoltoageOfBattery',
        system_data_storage_cycle: 'DSCycle',
        system_can_baud: 'CanBaud',
        system_485_1_baud: '485_1Baud',
        system_485_2_baud: '485_2Baud',
        system_485_1_check: '485_1Parity',
        system_485_2_check: '485_21Parity',
        system_485_address: '485Addr',
        system_sensor_type_includes: 'CSType(25-75)',
        system_current_sensor_range: 'CSRange',
        system_zero_filtering_range: 'ZFRangeOfCS',
        system_reverse_connection_sensor: 'RevConnOfCS',
        system_type: 'BatType',
        system_power_diagnosis_low: 'LowPowerOnSDT',
        system_power_diagnosis_high: 'HightPowerOnSDT',
        system_fan_on_temperature: 'FanOnTemp',
        system_fan_off_temperature: 'FanOffTemp',
        system_heating_on_temperature: 'HOnTemp',
        system_heating_off_temperature: 'HOffTemp',
        system_heating_off: 'HeatingOffSOC',
        system_heating_temperature_protection: 'HeatingTemperatureProtection',
        system_heating_temperature_release: 'HeatingTemperatureRelease',
        system_heating_temperature_sensing: 'HeattingTempSensingNum',
        system_insulation_testing_cycle: 'IDCycle',
        system_insulation_collection_enable: 'IAEnable',
        system_insulation_collection_delay: 'IADelay',
        system_balanced_opening_voltage: 'BalanceOnV',
        system_balanced_opening_mode: 'BalOpenMode',
        system_balanced_opening_difference: 'BalanceOnVdiff',
        system_balanced_closing_difference: 'BalOffVolDiffer',
        system_env_temperature_sensing: 'EnvTemperSense{data}Enable',
        system_sleep_time: 'Dormancy time',
        system_agreement: 'InverterProtocol',
        system_parallel: 'ParallelSystem',
        system_parallel_current: 'CurRatioOfParSys',
        system_balanced_opening_sensing: 'BalOpenEnable',
        charge_discharge: 'Charging and Discharging parameters',
        charge_discharge_rated_charging_current: 'RCCurrent',
        charge_discharge_rated_discharge_current: 'RDCurrent',
        charge_discharge_charging_cutoff_voltage: 'ChargingStopvoltage',
        charge_discharge_first_alarm_coefficient: 'IAlarmCurrDropCoef',
        charge_discharge_second_alarm_coefficient: 'IIAlarmCurrDropCoef',
        charge_discharge_first_down_voltage: 'ChargeIDownCurrVolPoint',
        charge_discharge_second_down_voltage: 'ChargeIIDownCurrVolPoint',
        charge_discharge_first_gear_coefficient: 'ChargeICurReduCoeff',
        charge_discharge_second_gear_coefficient: 'ChargeIICurReduCoeff',
        charge_discharge_recovery_release_value: 'ChargeRecoSOCHighRValue',
        charge_discharge_recovery_voltage_release: 'ChargeRecoVolRValue',
        charge_discharge_discharge_recovery_low: 'DischargeRecoSOCLowRValue',
        charge_discharge_discharge_recovery_release: 'DischargeRecoVolLowRValue',
        charge_discharge_full_charge_voltage: 'FullChargeCalVol',
        charge_discharge_vacuum_calibration_voltage: 'VaCalVoltage',
        charge_discharge_strong_charge_enable: 'ForcedChargingEnable',
        charge_discharge_full_charge_enable: 'ForcedFullChargeEnable',
        charge_discharge_strong_charge_on: 'ForcedChargingToStartSOCEnable',
        charge_discharge_Strong_charge_off: 'ForcedChargingToStopSOCEnable',
        charge_discharge_full_charge_days: 'DaysOfFullChargeOpening',
        charge_discharge_high_limit_voltage: 'LimitCurVolOfHighTotalVol',
        charge_discharge_high_limit_ratio: 'LimitCurRatioOfHighTotalVol',
        charge_discharge_low_limit_voltage: 'LimitCurVolOfLowTotalVol',
        charge_discharge_low_limit_ratio: 'LimitCurRatioOfLowTotalVol',
        charge_discharge_strong_charge_timeout_alarm: 'StrongChargeTimeoutAlarm',
        charge_discharge_floating_limiting_voltage: 'FloatingLimitingVoltage',
        charge_discharge_floating_limiting_current: 'FloatingLimitingCurrent',
        charge_discharge_floating_limiting_timeout: 'FloatingTimeout',
        charge_discharge_charging_request_start_time_1: 'ChargingRequestStartTimeZone1',
        charge_discharge_charging_request_end_time_1: 'ChargingRequestEndTimeZone1',
        charge_dischargee_charging_request_start_time_2: 'ChargingRequestStartTimeZone2',
        charge_discharge_charging_request_end_time_2: 'ChargingRequestEndTimeZone2',
        charge_discharge_charging_request_start_time_3: 'ChargingRequestStartTimeZone3',
        charge_discharge_charging_request_end_time_3: 'ChargingRequestEndTimeZone3',
        charge_discharge_heating_start_time_1: 'HeatingtStartTimeZone1',
        charge_discharge_heating_end_time_1: 'HeatingtEndTimeZone1',
        charge_discharge_request_duration: 'ChargingRequestDuration',
        charge_discharge_request_interval: 'ChargingRequestInterval',
        high_voltage: 'High Voltage power on',
        high_voltage_relay_type: 'Relay{data}TypeConf',
        high_voltage_di_type: 'DI{data}Type',
        high_voltage_charge_voltage_ratio: 'PCVolRatio',
        high_voltage_voltage_power_delay: 'HighVolPowerUpDelay',
        high_voltage_charge_completion_timeout: 'PrechargeCompTimeOut',
        high_voltage_charge_closure_time: 'PrechargingCloseMaxTime',
        high_voltage_charge_times: 'PrechargeNum',
        high_voltage_voltage_delay: 'HighVolDownDelay',
        high_voltage_open_circuit_detection: 'SupportOpenCirDetection',
        high_voltage_support_adhesion_detection: 'SupportAdhDecection',
        high_voltage_support_pre_charging: 'SupportPrecharge',
        high_voltage_copy_check_voltage_rate: 'CopyCheckVoltageRate',
        soc: 'SOC',
        soc_capacity_decay_cycles: '70%CACycles',
        soc_capacity_decay_low: 'LowPowerOf70%CA',
        soc_capacity_decay_high: 'HighPowerOf70%CA',
        soc_correction_rate_change: 'SOCCorrChangeRate',
        soc_calibration_interval_time: 'OCVCorrInterval',
        soc_correction_settling_time: 'OCVCorrStandingTime',
        soc_correction_step_size: 'OCVCorrStep',
        soc_correction_cutoff_current: 'OCVCorrCutOffCur',
        soc_virtual_low_holding: 'SOCVirLowHoldValue',
        soc_virtual_low_voltage: 'SOCVirLowVol',
        soc_battery_capacity_ratio_1: '10℃BatAvaCapRatio',
        soc_battery_capacity_ratio_2: '0℃BatAvaCapRatio',
        soc_battery_capacity_ratio_3: '-10℃BatAvaCapRatio',
        soc_battery_capacity_ratio_4: '-20℃BatAvaCapRatio',
        charge: 'Charging fault',
        charge_high_charging_pressure_1: 'TotalChargeVolHigh level I alarm',
        charge_high_charging_pressure_2: 'TotalChargeVolHigh level II alarm',
        charge_high_charging_pressure_3: 'TotalChargeVolHigh level III alarm',
        charge_charging_unit_1: 'ChargingMonomerHigh level I alarm',
        charge_charging_unit_2: 'ChargingMonomerHigh level II alarm',
        charge_charging_unit_3: 'ChargingMonomerHigh level III alarm',
        charge_charging_pressure_difference_1: 'ChargeVoltageDiffer level I alarm',
        charge_charging_pressure_difference_2: 'ChargeVoltageDiffer level II alarm',
        charge_charging_pressure_difference_3: 'ChargeVoltageDiffer level III alarm',
        charge_charging_high_temperature_1: 'ChargingHighTemper level I alarm',
        charge_charging_high_temperature_2: 'ChargingHighTemper level II alarm',
        charge_charging_high_temperature_3: 'ChargingHighTemper level III alarm',
        charge_charging_temperature_difference_1: 'ChargingTemperDiffer level I alarm',
        charge_charging_temperature_difference_2: 'ChargingTemperDiffer level II alarm',
        charge_charging_temperature_difference_3: 'ChargingTemperDiffer level III alarm',
        charge_low_temperature_charging_1: 'ChargingTemperLow level I alarm',
        charge_low_temperature_charging_2: 'ChargingTemperLow level II alarm',
        charge_low_temperature_charging_3: 'ChargingTemperLow level III alarm',
        charge_charging_overcurrent_1: 'ChargingOverCurr level I alarm',
        charge_charging_overcurrent_2: 'ChargingOverCurr level II alarm',
        charge_charging_overcurrent_3: 'ChargingOverCurr level III alarm',
        discharge: 'Discharge fault',
        discharge_low_discharge_pressure_1: 'TotalDischargeVolLow level I alarm',
        discharge_low_discharge_pressure_2: 'TotalDischargeVolLow level II alarm',
        discharge_low_discharge_pressure_3: 'TotalDischargeVolLow level III alarm',
        discharge_low_discharge_monomer_1: 'DischargeMonomerLow level I alarm',
        discharge_low_discharge_monomer_2: 'DischargeMonomerLow level II alarm',
        discharge_low_discharge_monomer_3: 'DischargeMonomerLow level III alarm',
        discharge_discharge_voltage_difference_1: 'DischargeVoltageDiffer level I alarm',
        discharge_discharge_voltage_difference_2: 'DischargeVoltageDiffer level II alarm',
        discharge_discharge_voltage_difference_3: 'DischargeVoltageDiffer level III alarm',
        discharge_high_discharge_temperature_1: 'DischargeHighTemper level I alarm',
        discharge_high_discharge_temperature_2: 'DischargeHighTemper level II alarm',
        discharge_high_discharge_temperature_3: 'DischargeHighTemper level III alarm',
        discharge_discharge_temperature_difference_1: 'DischargeTemperDiffer level I alarm',
        discharge_discharge_temperature_difference_2: 'DischargeTemperDiffer level II alarm',
        discharge_discharge_temperature_difference_3: 'DischargeTemperDiffer level III alarm',
        discharge_low_discharge_temperature_1: 'DischargeLowTemper level I alarm',
        discharge_low_discharge_temperature_2: 'DischargeLowTemper level II alarm',
        discharge_low_discharge_temperature_3: 'DischargeLowTemper level III alarm',
        discharge_discharge_overcurrent_1: 'DischargeOverCurr level I alarm',
        discharge_discharge_overcurrent_2: 'DischargeOverCurr level II alarm',
        discharge_discharge_overcurrent_3: 'DischargeOverCurr level III alarm',
        relay: 'Relay',
        relay_high_temperature_1: 'RelayHighTemper level I alarm',
        relay_high_temperature_2: 'RelayHighTemper level II alarm',
        relay_high_temperature_3: 'RelayHighTemper level III alarm',
        relay_low_temperature_1: 'RelayLowTemper level I alarm',
        relay_low_temperature_2: 'RelayLowTemper level II alarm',
        relay_low_temperature_3: 'RelayLowTemper level III alarm',
        common: 'General failure',
        common_low_soc_1: 'SOCLow level I alarm',
        common_low_soc_2: 'SOCLow level II alarm',
        common_low_soc_3: 'SOCLow level III alarm',
        common_insulation_leakage_1: 'InsuLeakage level I alarm',
        common_insulation_leakage_2: 'InsuLeakage level II alarm',
        common_insulation_leakage_3: 'InsuLeakage level III alarm',
        common_temperature_rise_alarm_1: 'TemperRiseAlarm level I alarm',
        common_temperature_rise_alarm_2: 'TemperRiseAlarm level II alarm',
        common_temperature_rise_alarm_3: 'TemperRiseAlarm level III alarm',
        common_high_temperature_env_1: 'EnvTemperHigh level I alarm',
        common_high_temperature_env_2: 'EnvTemperHigh level II alarm',
        common_high_temperature_env_3: 'EnvTemperHigh level III alarm',
        common_low_temperature_env_1: 'EnvTemperLow level I alarm',
        common_low_temperature_env_2: 'EnvTemperLow level II alarm',
        common_low_temperature_env_3: 'EnvTemperLow level III alarm',
        common_circulation_1: 'CirulCur level I alarm',
        common_circulation_2: 'CirulCur level II alarm',
        common_circulation_3: 'CirulCur level III alarm',
        common_abnormal_voltage_cable_1: 'VoltageCheckCablesErrorAlarm1',
        common_abnormal_voltage_cable_2: 'VoltageCheckCablesErrorAlarm2',
        common_abnormal_voltage_cable_3: 'VoltageCheckCablesErrorAlarm3',
        common_temperature_detection_abnormality_1: 'TemperCheckCablesErrorAlarm1',
        common_temperature_detection_abnormality_2: 'TemperCheckCablesErrorAlarm2',
        common_temperature_detection_abnormality_3: 'TemperCheckCablesErrorAlarm3',
        table_name: 'Name',
        table_threshold: 'Threshold',
        table_release_threshold: 'Release Threshold',
        table_delayed: 'Delayed',
        table_release_delayed: 'Release Delayed',
        table_handle: 'Handle',
        high_voltage_open_circuit_delay: 'OpenCircuitDelay',
        high_voltage_support_adhesion_delay: 'SupportAdhesionDelay',
        soc_high_auxiliary_check_point: 'HighAuxiliaryCheckPoint',
        soc_low_auxiliary_check_point: 'LowAuxiliaryCheckPoint',
        high_current_socHigh_auxiliary_check_voltage: 'LargeHighAuxiliaryCheckVoltage',
        middle_current_socHigh_auxiliary_check_voltage: 'MiddleHighAuxiliaryCheckVoltage',
        low_current_soc_high_auxiliary_check_voltage: 'SmallHighAuxiliaryCheckVoltage',
        high_current_soc_low_auxiliary_check_voltage: 'LargeLowAuxiliaryCheckVoltage',
        middle_current_soc_low_auxiliary_check_voltage: 'MiddleLowAuxiliaryCheckVoltage',
        low_current_soc_low_auxiliary_check_voltage: 'SmallLowAuxiliaryCheckVoltage',
        soc_high_auxiliary_check_voltage_high_current: 'LargeHighAuxiliaryCheckCurrent',
        soc_high_auxiliary_check_voltage_middle_current: 'MiddleHighAuxiliaryCheckCurrent',
        soc_high_auxiliary_check_voltage_low_current: 'SmallHighAuxiliaryCheckCurrent',
        soc_low_auxiliary_check_voltage_high_current: 'LargeLowAuxiliaryCheckCurrent',
        soc_low_auxiliary_check_voltage_middle_current: 'MiddleLowAuxiliaryCheckCurrent',
        soc_low_auxiliary_check_voltage_low_current: 'SmallLowAuxiliaryCheckCurrent',
        soc_low_auxiliary_check_voltage_keep_time: 'SmallLowAuxiliaryCheckKeepTime',
        soc_total_charging: 'TotalChargingCapacity',
        soc_total_discharge: 'TotalDischargeCapacity',
        soc_total_charge_discharge_cycles: 'TotalChargeDischargeCycles'
      },
      inverter: {
        megmeet: {
          title: 'Inverter Settings',
          systemSettings: 'System Settings',
          systemControl: 'System Control',
          systemParams: 'System Safety Parameter',
          backwash: 'Export Power Setting',
          energy: 'Energy Management Mode Setting',
          time: 'Time period {data} mode setting',
          systemSettings_real_time: 'Inverter real-time time',
          systemSettings_model: 'Inverter Type',
          systemSettings_code: 'Inverter SN',
          systemSettings_device_model: 'Inverter Model',
          systemSettings_manufacturer: 'Inverter Manufacturer',
          systemSettings_battery_manufacturer: 'Battery Manufacturer',
          systemSettings_meter_manufacturer: 'Meter Manufacturer',
          systemSettings_485_protocol: '485 Protocol',
          systemSettings_485_address: '485 Address',
          systemSettings_485_baud: '485 Baudrate',
          systemSettings_485_2_address: '485-2 Address',
          systemSettings_485_2_baud: '485-2 Baudrate',
          systemControl_shutdown: 'Remote Startup',
          systemControl_clearing_power: 'Clear Generation',
          systemControl_clearing_fault: 'Clear Error Log',
          systemControl_factory_settings: 'Reset Factory',
          systemParams_rule: 'Safety',
          systemParams_undervoltage_value_1: 'Grid Under Voltage Level 1',
          systemParams_undervoltage_value_2: 'Grid Under Voltage Level 2',
          systemParams_undervoltage_value_3: 'Grid Under Voltage Level 3',
          systemParams_overvoltage_value_1: 'Grid Over Voltage Level 1',
          systemParams_overvoltage_value_2: 'Grid Over Voltage Level 2',
          systemParams_undervoltage_time_1: 'Grid Under Voltage Level 1 Time',
          systemParams_undervoltage_time_2: 'Grid Under Voltage Level 2 Time',
          systemParams_undervoltage_time_3: 'Grid Under Voltage Level 3 Time',
          systemParams_overvoltage_time_1: 'Grid Over Voltage Level 1 Time',
          systemParams_overvoltage_time_2: 'Grid Over Voltage Level 2 Time',
          systemParams_undervoltage_differ_value: 'Grid Under Voltage Hysteresis',
          systemParams_overvoltage_differ_value: 'Grid Over Voltage Hysteresis',
          systemParams_underfrequent_value_1: 'Grid Under Frequency Level 1',
          systemParams_underfrequent_value_2: 'Grid Under Frequency Level 2',
          systemParams_overfrequent_value_1: 'Grid Over Frequency Level 1',
          systemParams_overfrequent_value_2: 'Grid Over Frequency Level 2',
          systemParams_underfrequent_time_1: 'Grid Under Frequency Level 1 Time',
          systemParams_underfrequent_time_2: 'Grid Under Frequency Level 2 Time',
          systemParams_overfrequent_time_1: 'Grid Over Frequency Level 1 Time',
          systemParams_overfrequent_time_2: 'Grid Over Frequency Level 2 Time',
          systemParams_underfrequent_differ_value: 'Grid Under Frequency Hysteresis',
          systemParams_overfrequent_differ_value: 'Grid overclocking protection return difference',
          backwash_reflux_function: 'Export Power Feature',
          backwash_reflux_power: 'Export Power',
          energy_mode: 'Energy Management Mode',
          energy_charging_power: 'Charge Power Percentage',
          energy_discharge_power: 'Percentage of discharge power',
          energy_stop_soc: 'Charge and Discharge Stop SOC',
          energy_deep_dod: 'Battery DOD',
          time_header_name: 'Name',
          time_header_mode: 'Mode',
          time_header_startTime: 'Start Time',
          time_header_endTime: 'End Time',
          time_header_charge_mode: 'Charge-discharge mode',
          time_header_charge_power: 'Charge-discharge Percentage(%)',
          time_header_charge_soc: 'Stop Charge-discharge SOC(%)'
        },
        luxpowertek: {
          title: 'Inverter Settings',
          generalSettings: 'Common Setting',
          generalSettings_time: 'Time',
          systemSettings_model_addr: 'MODBUS Addr',
          systemSettings_pv_input_mode: 'PV Input Mode',
          systemSettings_neutral_detect_enable: 'Neutral Detect Enable',
          systemSettings_star_pv_volt: 'Start PV Volt',
          systemSettings_model: 'Model',
          systemSettings_measurement: 'Measurement',
          systemSettings_meter_type: 'Meter Type',
          systemSettings_ct_sample_ratio: 'CT Sample Ratio',
          systemSettings_ct_direction_reversed: 'CT Direction Reversed',
          systemSettings_ct_power_offset: 'CT Power Offset',
          systemSettings_battery_type: 'Battery Type',
          systemSettings_lead_acid_capacity: 'Lead-acid Capacity',
          systemSettings_ead_acid_battery_setting: 'Lead-acid Battery Setting',
          systemSettings_absorb_voltage: 'Absorb Voltage',
          systemSettings_float_voltage: 'Float Voltage',
          systemSettings_on_grid_discharge_derate_vbatt: 'On Grid Discharge Derate Vbatt',
          systemSettings_lithium_brand: 'Lithium Brand',
          systemSettings_reuse_of_pv_ct: 'Reuse of PV CT',
          systemSettings_ios_enable: 'ISO Enable',
          systemSettings_firmware_version: 'Firmware version',
          systemSettings_lcd_version: 'LCD Version',
          systemSettings_lcd_password: 'LCD Password',
          applicationSettings: 'Application Setting',
          applicationSettings_eps_voltage_set: 'EPS Voltage Set',
          applicationSettings_pv_grid_off: 'PV Grid Off',
          applicationSettings_power_backup: 'Power Backup',
          applicationSettings_seamless_eps_switching: 'Seamless EPS switching',
          applicationSettings_grid_sell_back: 'Grid Sell Back',
          applicationSettings_grid_sell_back_power: 'Grid Sell Back Power',
          applicationSettings_fast_zero_export: 'Fast Zero Export',
          applicationSettings_go_to_off_grid: 'Go to off-grid',
          applicationSettings_pv_arc: 'PV Arc',
          applicationSettings_pv_arc_fault_clear: 'PV Arc Fault Clear',
          applicationSettings_grid_loss_warning_clear: 'Grid Loss Warning Clear',
          applicationSettings_rsd: 'RSD',
          applicationSettings_normal_standby: 'Normal/Standby',
          applicationSettings_restart_inverter: 'Restart Inverter',
          applicationSettings_micro_grid: 'Micro-Grid',
          applicationSettings_max_ac_input_power: 'Max. AC Input Power',
          applicationSettings_system_charge_soc_limit: 'System Charge SOC Limit',
          applicationSettings_system_charge_volt_limit: 'System Charge Volt Limit',
          applicationSettings_Parallel_system: 'Parallel System',
          applicationSettings_set_system_type: 'Set System Type',
          applicationSettings_share_battery: 'Share Battery',
          applicationSettings_set_composed_phase: 'Set Composed Phase',
          gridSettings: 'Grid Connect Setting',
          gridSettings_grid_regulation: 'Grid Regulation',
          gridSettings_grid_frequency: 'Grid Frequency',
          gridSettings_grid_type: 'Grid Type',
          gridSettings_connection: 'Connection',
          gridSettings_connect_time: 'Connect Time',
          gridSettings_reconnect_time: 'Reconnect Time',
          gridSettings_grid_volt_connect_low: 'Grid Volt Connect Low',
          gridSettings_grid_volt_connect_high: 'Grid Volt Connect High',
          gridSettings_grid_freq_connect_low: 'Grid Freq Connect Low',
          gridSettings_grid_freq_connect_high: 'Grid Freq Connect High',
          gridSettings_power_command: 'Power Command',
          gridSettings_active_power_percent: 'Active Power Percent',
          gridSettings_ovf_load_derate_enable: 'OVF Load Derate Enable',
          gridSettings_reactive_power_type: 'Reactive Power Type',
          gridSettings_drms_enable: 'DRMS Enable',
          gridSettings_pf_cmd: 'PF CMD',
          gridSettings_reactive_power_percent: 'Reactive Power Percent',
          gridSettings_grid_protection: 'Grid Protection',
          gridSettings_grid_volt_limit1_low: 'Grid Volt Limit1 Low',
          gridSettings_grid_volt_limit2_low: 'Grid Volt Limit2 Low',
          gridSettings_grid_volt_limit3_low: 'Grid Volt Limit3 Low',
          gridSettings_grid_volt_limit1_high: 'Grid Volt Limit1 High',
          gridSettings_grid_volt_limit2_high: 'Grid Volt Limit2 High',
          gridSettings_grid_volt_limit3_high: 'Grid Volt Limit3 High',
          gridSettings_grid_freq_limit1_low: 'Grid Freq Limit1 Low',
          gridSettings_grid_freq_limit2_low: 'Grid Freq Limit2 Low',
          gridSettings_grid_freq_limit3_low: 'Grid Freq Limit3 Low',
          gridSettings_grid_freq_limit1_high: 'Grid Freq Limit1 High',
          gridSettings_grid_freq_limit2_high: 'Grid Freq Limit2 High',
          gridSettings_grid_freq_limit3_high: 'Grid Freq Limit3 High',
          gridSettings_grid_volt_mov_avg_high: 'Grid Volt Mov Avg High',
          gridSettings_power_soft_start_slope: 'Power Soft Start Slope',
          gridSettings_grid_soft_start: 'Grid Soft Start',
          chargeSettings: 'Charge Setting',
          chargeSettings_batt_charge_control: 'Batt Charge Control',
          chargeSettings_charge_current_limit: 'Charge Current Limit(Adc)',
          chargeSettings_charge_last: 'Charge Last',
          chargeSettings_ac_charge: 'AC Charge',
          chargeSettings_ac_charge_enable: 'AC Charge Enable',
          chargeSettings_ac_charge_based_on: 'AC Charge Based On',
          chargeSettings_ac_charge_power: 'AC Charge Power',
          chargeSettings_start_ac_charge_soc: 'Start AC Charge SOC',
          chargeSettings_start_ac_charge_volt: 'Start AC Charge Volt',
          chargeSettings_stop_ac_charge_soc: 'Stop AC Charge SOC',
          chargeSettings_stop_ac_charge_volt: 'Stop AC Charge Volt',
          chargeSettings_ac_charge_start_time_1: 'AC Charge Start Time 1',
          chargeSettings_ac_charge_start_time_2: 'AC Charge Start Time 2',
          chargeSettings_ac_charge_start_time_3: 'AC Charge Start Time 3',
          chargeSettings_ac_charge_end_time_1: 'AC Charge End Time 1',
          chargeSettings_ac_charge_end_time_2: 'AC Charge End Time 2',
          chargeSettings_ac_charge_end_time_3: 'AC Charge End Time 3',
          chargeSettings_charge_first_title: 'Charge First',
          chargeSettings_charge_first: 'Charge First',
          chargeSettings_charge_first_power: 'Charge First Power',
          chargeSettings_Stop_charge_first_soc: 'Stop Charge First SOC',
          chargeSettings_Stop_charge_first_volt: 'Stop Charge First Volt',
          chargeSettings_charge_first_start_time_1: 'Charge First Start Time 1',
          chargeSettings_charge_first_start_time_2: 'Charge First Start Time 2',
          chargeSettings_charge_first_start_time_3: 'Charge First Start Time 3',
          chargeSettings_charge_first_end_time_1: 'Charge First End Time 1',
          chargeSettings_charge_first_end_time_2: 'Charge First End Time 2',
          chargeSettings_charge_first_end_time_3: 'Charge First End Time 3',
          generatorSettings: 'Generator Setting',
          generatorSettings_batt_charge_current_limit: 'Batt Charge Current Limit(Adc)',
          generatorSettings_gen_rated_power: 'Gen Rated Power',
          generatorSettings_charge_start_volt: 'Charge Start Volt',
          generatorSettings_charge_start_soc: 'Charge Start SOC',
          generatorSettings_charge_end_volt: 'Charge End Volt',
          generatorSettings_charge_end_soc: 'Charge End SOC',
          disChargeSettings: 'Discharge Setting',
          disChargeSettings_batt_discharge_control: 'Batt Discharge Control',
          disChargeSettings_discharge_current_limit: 'Discharge Current Limit(Adc)',
          disChargeSettings_start_discharge_p_import: 'Start Discharge P_import',
          disChargeSettings_on_grid_cut_off_soc: 'On-Grid Cut-Off SOC',
          disChargeSettings_off_grid_cut_off_soc: 'Off-Grid Cut-Off SOC',
          disChargeSettings_on_grid_cut_off_volt: 'On-Grid Cut-Off Volt',
          disChargeSettings_off_grid_cut_off_volt: 'Off-Grid Cut-Off Volt',
          disChargeSettings_forced_discharge: 'Forced Discharge',
          disChargeSettings_forced_discharge_enable: 'Forced Discharge Enable',
          disChargeSettings_forced_discharge_power: 'Forced Discharge Power',
          disChargeSettings_stop_discharge_soc: 'Stop Discharge SOC',
          disChargeSettings_stop_discharge_volt: 'Stop Discharge Volt',
          disChargeSettings_pvsell_to_grid: 'PVSellToGrid(Comp. w/ NEM3.0)',
          disChargeSettings_forced_discharge_start_time_1: 'Forced Discharge Start Time 1',
          disChargeSettings_forced_discharge_start_time_2: 'Forced Discharge Start Time 2',
          disChargeSettings_forced_discharge_start_time_3: 'Forced Discharge Start Time 3',
          disChargeSettings_forced_discharge_end_time_1: 'Forced Discharge End Time 1',
          disChargeSettings_forced_discharge_end_time_2: 'Forced Discharge End Time 2',
          disChargeSettings_forced_discharge_end_time_3: 'Forced Discharge End Time 3',
          disChargeSettings_peak_shaving: 'Peak Shaving',
          disChargeSettings_grid_peak_shaving: 'Grid Peak-Shaving',
          disChargeSettings_grid_peak_shaving_power_1: 'Grid Peak-Shaving Power 1',
          disChargeSettings_grid_peak_shaving_power_2: 'Grid Peak-Shaving Power 2',
          disChargeSettings_start_peak_shaving_volt_1: 'Start Peak-Shaving Volt 1',
          disChargeSettings_start_peak_shaving_soc_1: 'Start Peak-Shaving SOC 1',
          disChargeSettings_start_peak_shaving_volt_2: 'Start Peak-Shaving Volt 2',
          disChargeSettings_start_peak_shaving_soc_2: 'Start Peak-Shaving SOC 2',
          disChargeSettings_peak_shaving_start_time_1: 'Peak Shaving Start Time 1',
          disChargeSettings_peak_shaving_start_time_2: 'Peak Shaving Start Time 2',
          disChargeSettings_peak_shaving_end_time_1: 'Peak Shaving End Time 1',
          disChargeSettings_peak_shaving_end_time_2: 'Peak Shaving End Time 2',
          disChargeSettings_ac_couple_title: 'AC Couple',
          disChargeSettings_ac_couple: 'AC Couple',
          disChargeSettings_ac_couple_start_volt: 'AC Couple Start Volt',
          disChargeSettings_ac_couple_start_soc: 'AC Couple Start SOC',
          disChargeSettings_ac_couple_end_volt: 'AC Couple End Volt',
          disChargeSettings_ac_couple_end_soc: 'AC Couple End SOC',
          disChargeSettings_smart_load_title: 'Smart Load',
          disChargeSettings_smart_load: 'Smart Load',
          disChargeSettings_start_pv_power: 'Start PV Power',
          disChargeSettings_grid_always_on: 'Grid Always On',
          disChargeSettings_smart_load_start_volt: 'Smart Load Start Volt',
          disChargeSettings_smart_load_start_soc: 'Smart Load Start SOC',
          disChargeSettings_smart_load_end_volt: 'Smart Load End Volt',
          disChargeSettings_smart_load_end_soc: 'Smart Load End SOC',
          resetSettings: 'Reset',
          resetSettings_all_to_default: 'All to Default',
          collectorSettings: 'Dongle Set - BA32001486 - Wi-Fi',
          collectorSettings_server_ip_and_port: 'Server IP and Port'
        },
        inteless: {
          title: 'Inverter Settings',
          basicSettings: 'Basic setup',
          basicSettings_alarm: 'Beekeer alarm',
          basicSettings_password_input: 'Password input',
          basicSettings_password_setting: 'Password setting',
          basicSettings_model: 'Model id settings',
          modeSettings: 'Working Mode Setting',
          modeSettings_grid_mode: 'Off/on grid mode',
          modeSettings_charging_enable: 'Grid charging enable',
          modeSettings_pv_energy_manage: 'PV energy manage',
          modeSettings_battery_energy_manage: 'Battery discharge energy manage',
          modeSettings_wiring_type: 'AC Wiring Type',
          modeSettings_output_voltage: 'Output voltage setting',
          modeSettings_timing_charging: 'Timing charging',
          modeSettings_timing_discharging: 'Timing discharging',
          modeSettings_table_name: 'Name',
          modeSettings_table_startTime: 'Start time',
          modeSettings_table_endTime: 'End time',
          modeSettings_table_maxPower: 'Max power(W)',
          modeSettings_table_stopSoc: 'Stop SOC(%)',
          modeSettings_table_1: 'Timing Chg Time Period1',
          modeSettings_table_2: 'Timing Chg Time Period2',
          modeSettings_table_3: 'Timing Chg Time Period3',
          modeSettings_table_4: 'Timing DisChg Time Period1',
          modeSettings_table_5: 'Timing DisChg Time Period2',
          modeSettings_table_6: 'Timing DisChg Time Period3',
          modeSettings_parallel_mode: 'Parallel Mode',
          batterySettings: 'Battery Settings',
          batterySettings_type: 'Battery type',
          batterySettings_bms_enable: 'BMS comm. enable',
          batterySettings_bms_protocol: 'BMS comm. protocol',
          batterySettings_mode: 'Battery chg. curr. limit mode',
          batterySettings_max_charging_current: 'Max charging current',
          batterySettings_max_charging_voltage: 'Maximum chg. voltage',
          batterySettings_stop_discharge_voltage: 'Stop discharge voltage',
          batterySettings_stop_dchg_delay_time: 'Stop dchg. delay time',
          batterySettings_battery_under_volt_alarm: 'Battery under volt. alarm',
          batterySettings_eod_recovery_voltage: 'Eod recovery voltage',
          batterySettings_batt_Recharging_voltage: 'Batt. Recharging voltage',
          batterySettings_max_chg_curr_by_grid: 'Max. chg. curr. by Grid',
          batterySettings_battery_curr_stop_chg: 'Battery curr. stop chg.',
          batterySettings_batt_soc_low_alarm: 'Batt. SOC low alarm',
          batterySettings_discharge_cutoff_soc: 'Discharge cutoff SOC',
          batterySettings_bat_soc_stop_chg: 'Bat. SOC stop chg.',
          batterySettings_mains_switching_voltage: 'Mains switching voltage',
          batterySettings_switch_the_city_electric: 'Switch the city electric SOC',
          batterySettings_max_batt_discharg_current: 'Max batt discharg current',
          batterySettings_batt_temp_compen_enable: 'batt temp compen. enable',
          parallelSettings: 'Parallel Settings',
          parallelSettings_grid_standard: 'Grid standard',
          parallelSettings_grid_frequency: 'Grid frequency',
          parallelSettings_buy_power_max: 'Buy power max. setting',
          parallelSettings_sell_power_max: 'Sell power max. setting',
          parallelSettings_ct_ratio: 'CT ratio',
          parallelSettings_zero_export_power: 'Zero-export power',
          parallelSettings_on_grid_reactive_power: 'On grid reactive power setting',
          parallelSettings_on_grid_pf: 'On grid PF setting',
          parallelSettings_enter_service_enable: 'Enter service enable',
          parallelSettings_normal_connect_delay_time: 'Normal connect delay time',
          parallelSettings_normal_connect_power_ramp_rate: 'Normal connect power ramp rate',
          parallelSettings_connect_voltage_low_point: 'Connect voltage low point',
          parallelSettings_connect_voltage_high_point: 'Connect voltage High point',
          parallelSettings_connect_frequency_low_point: 'Connect frequency low point',
          parallelSettings_connect_frequency_high_point: 'Connect frequency High point',
          parallelSettings_reconnect_delay_time: 'Reconnect delay time',
          parallelSettings_reconnect_power_ramp_rate: 'Reconnect power ramp rate',
          parallelSettings_lv1_trip_value: 'LV1 trip value',
          parallelSettings_lv1_trip_time: 'LV1 trip time',
          parallelSettings_lv2_trip_value: 'LV2 trip value',
          parallelSettings_lv2_trip_time: 'LV2 trip time',
          parallelSettings_hv1_trip_value: 'HV1 trip value',
          parallelSettings_hv1_trip_time: 'HV1 trip time',
          parallelSettings_hv2_trip_value: 'HV2 trip value',
          parallelSettings_hv2_trip_time: 'HV2 trip time',
          parallelSettings_lf1_trip_value: 'LF1 trip value',
          parallelSettings_lf1_trip_time: 'LF1 trip time',
          parallelSettings_lf2_trip_value: 'LF2 trip value',
          parallelSettings_lf2_trip_time: 'LF2 trip time',
          parallelSettings_hf1_trip_value: 'HF1 trip value',
          parallelSettings_hf1_trip_time: 'HF1 trip time',
          parallelSettings_hf2_trip_value: 'HF2 trip value',
          parallelSettings_hf2_trip_time: 'HF2 trip time',
          parallelSettings_frequency: 'Frequency Droop (F-P)',
          parallelSettings_volt_watt: 'Volt-Watt (V-P) curve',
          parallelSettings_volt_var: 'Volt-Var (V-Q) curve',
          parallelSettings_watt_var: 'Watt-Var (P-Q) curve',
          parallelSettings_watt_pf: 'Watt-PF (P-PF) curve',
          parallelSettings_lvrt: 'LVRT/HVRT',
          advanceSettings: 'Advance Setup',
          advanceSettings_generator_interface_work_mode: 'Generator interface work mode',
          advanceSettings_generator_rate_power: 'Generator rate power',
          advanceSettings_generator_charging_enable: 'Generator charging enable',
          advanceSettings_generator_charging_max_current: 'Generator charging max current',
          advanceSettings_pen_connect_enable: 'PE-N connect enable',
          advanceSettings_pv_riso_check_enable: 'PV Riso check enable',
          advanceSettings_afci_check_enable: 'AFCI check enable',
          advanceSettings_leakage_curr_protection_enable: 'Leakage curr. protection enable',
          advanceSettings_bms_comm_error_stop: 'BMS comm. error stop',
          advanceSettings_power_saveing_mode: 'Power saveing mode',
          advanceSettings_ct_automatic_detection_enable: 'CT automatic detection enable',
          advanceSettings_ct_manual_enable: 'CT manual enable',
          advanceSettings_inv_current_limit_coef: 'Inv current limit coef',
          advanceSettings_afci_failure_manually_clearing: 'AFCI failure manually clearing',
          advanceSettings_reset_factory: 'Reset Factory',
          advanceSettings_reset_control: 'Reset Control'
        },
        sosen: {
          title: 'Inverter Settings',
          powerOnOffSettings: 'Power On/Off',
          powerOnOffSettings_control: 'Power On/Off Control',
          powerOnOffSettings_auto_enable: 'Auto Power On Enable',
          userModeSettings: 'User Mode',
          userModeSettings_on_soc: 'On-grid Battery Reserve SOC',
          userModeSettings_off_soc: 'Off-grid Battery Reserve SOC',
          userModeSettings_mode_setting: 'Mode Setting',
          userModeSettings_work_time: 'Working Day Time Setting',
          userModeSettings_work_time_error_end: 'End time must be 23:59',
          userModeSettings_work_time_error_order: 'The End Time Must Be Later Than The Start Time',
          userModeSettings_nwork_time: 'Non Working Day Time Setting',
          userModeSettings_work_times: 'Time Setting',
          operationConfigSettings: 'Operation Config',
          operationConfigSettings_grid_output_max_power: 'Grid Output Max Power',
          operationConfigSettings_grid_input_max_power: 'Grid Input Max Power',
          operationConfigSettings_grid_output_max_apparent: 'Grid Output Max Apparent',
          operationConfigSettings_export_mode_enable: 'Export Mode Enable',
          operationConfigSettings_grid_power_compensation: 'Grid Power Compensation',
          operationConfigSettings_max_export_power: 'Max export Power',
          generatorControlSettings: 'Generator Control',
          generatorControlSettings_setting: 'Generator Setting',
          generatorControlSettings_gen_warm_time: 'Gen Warm Time',
          generatorControlSettings_start_gen_soc: 'Start Gen SOC',
          generatorControlSettings_stop_gen_soc: 'Stop Gen SOC',
          generatorControlSettings_gen_max_using_power: 'Gen Max Using Power',
          generatorControlSettings_gen_max_running_time: 'Gen Max Running Time',
          generatorControlSettings_gen_cooling_time: 'Gen Cooling Time',
          generatorControlSettings_gen_start_stop_test: 'Gen Start Stop Test',
          otherSettingSettings: 'Other Setting',
          otherSettingSettings_record_clear: 'Record Clear',
          otherSettingSettings_battery_active: 'Battery Active',
          otherSettingSettings_afci_alarm_clear: 'AFCI Alarm Clear',
          otherSettingSettings_tip: 'Are you sure to send command?',
          peripheralConfigurationSettings: 'Peripheral Configuration',
          peripheralConfigurationSettings_grid_standard_type: 'Grid Standard Type',
          peripheralConfigurationSettings_grid_rate_volt: 'Grid Rate Volt',
          peripheralConfigurationSettings_grid_rate_frequency: 'Grid Rate Frequency',
          peripheralConfigurationSettings_meter_sensor_type: 'Meter Sensor Type',
          peripheralConfigurationSettings_external_ct_ratio: 'External CT Ratio',
          peripheralConfigurationSettings_meter_address: 'Meter Address',
          peripheralConfigurationSettings_meter_manufacturer: 'Meter Manufacturer',
          peripheralConfigurationSettings_battery_protocol: 'Battery Protocol',
          peripheralConfigurationSettings_battery_communication_type: 'Battery Communication Type',
          peripheralConfigurationSettings_battery_type: 'Battery Type',
          peripheralConfigurationSettings_mppt_control_mode: 'MPPT Control Mode',
          peripheralConfigurationSettings_mppt_parallel_mode: 'MPPT Parallel Mode',
          peripheralConfigurationSettings_mppt_quantity: 'MPPT Quantity',
          peripheralConfigurationSettings_mppt_power: 'MPPT Power',
          peripheralConfigurationSettings_mppt_disturbed_step_size: 'MPPT Disturbed Step Size',
          peripheralConfigurationSettings_cvt_volt: 'CVT Volt',
          switchConfigSettings: 'Switch Config',
          switchConfigSettings_drm_enable: 'DRM Enable',
          switchConfigSettings_afci_enable: 'AFCI Enable',
          switchConfigSettings_battery_warnning_enable: 'Battery Warnning Enable',
          switchConfigSettings_grid_abnormal_warnning_enable: 'Grid Abnormal Warnning Enable',
          switchConfigSettings_external_control_mode_enable: 'External Control Mode Enable',
          switchConfigSettings_active_island_enable: 'Active Island Enable',
          switchConfigSettings_preventive_pid_enable: 'Preventive PID Enable',
          switchConfigSettings_battery_temp_compensation_enable: 'Battery Temp Compensation Enable',
          switchConfigSettings_insulation_detection_enable: 'Insulation Detection Enable',
          switchConfigSettings_leakage_detection_enable: 'Leakage Detection Enable',
          switchConfigSettings_relay_self_check_enable: 'Relay Self-Check Enable',
          switchConfigSettings_device_lock: 'Device Lock',
          switchConfigSettings_remote_restart: 'Remote Restart',
          switchConfigSettings_factory_restore: 'Factory Restore',
          switchConfigSettings_grid_protection_parameters_reset: 'Grid Protection Parameters Reset',
          batSettingSettings: 'Bat Setting',
          batSettingSettings_number_of_batteries_in_parallel: 'Number Of Batteries In Parallel',
          batSettingSettings_battery1_capcity_setting: 'Battery1 Capcity Setting',
          batSettingSettings_battery_discharge_stop_volt: 'Battery Discharge Stop Volt',
          batSettingSettings_charge_rate: 'Charge Rate',
          batSettingSettings_equalization_voltage: 'Battery Equalization Voltage',
          batSettingSettings_floating_charging_voltage: 'Floating Charging Voltage',
          batSettingSettings_over_voltage_protect_point: 'Battery Over Voltage Protect Point',
          batSettingSettings_under_voltage_protect_point: 'Battery Under Voltage Protect Point',
          batSettingSettings_max_charge_current: 'Battery Max Charge Current',
          batSettingSettings_max_discharge_current: 'Battery Max Discharge Current',
          batSettingSettings_max_charge_power: 'Battery Max Charge Power',
          batSettingSettings_max_discharge_power: 'Battery Max Discharge Power',
          batSettingSettings_battery_temperature_compensation: 'Battery Temperature Compensation',
          powerDebugSettings: 'Power Debug',
          powerDebugSettings_enable: 'Power Debug Enable',
          basicConfigurationSettings: 'Basic Configuration',
          basicConfigurationSettings_power_factor: 'Power Factor',
          basicConfigurationSettings_10min_grid_voltage_point: '10min Grid Voltage Point',
          basicConfigurationSettings_power_on_grid_connection_recovery_time: 'Power-on Grid Connection Recovery Time',
          basicConfigurationSettings_power_on_active_power_recovery_rate: 'Power-on Active Power Recovery Rate',
          basicConfigurationSettings_fault_active_power_recovery_rate: 'Fault Active Power Recovery Rate',
          basicConfigurationSettings_fault_grid_reconnection_time: 'Fault Grid Reconnection Time',
          gridProtectSettings: 'Grid Protect',
          gridProtectSettings_under_volt_1: 'Grid Under Volt I',
          gridProtectSettings_under_volt_2: 'Grid Under Volt II',
          gridProtectSettings_under_volt_3: 'Grid Under Volt III',
          gridProtectSettings_over_volt_1: 'Grid Over Volt I',
          gridProtectSettings_over_volt_2: 'Grid Over Volt II',
          gridProtectSettings_under_volt_time_1: 'Grid Under Volt Time I',
          gridProtectSettings_under_volt_time_2: 'Grid Under Volt Time II',
          gridProtectSettings_under_volt_time_3: 'Grid Under Volt Time III',
          gridProtectSettings_over_volt_time_1: 'Grid Over Volt Time I',
          gridProtectSettings_over_volt_time_2: 'Grid Over Volt Time II',
          gridProtectSettings_under_volt_protect: 'Grid Under Volt Protect',
          gridProtectSettings_over_volt_protect: 'Grid Over Volt Protect',
          gridProtectSettings_under_freq_1: 'Grid Under Freq I',
          gridProtectSettings_under_freq_2: 'Grid Under Freq II',
          gridProtectSettings_over_freq_1: 'Grid Over Freq I',
          gridProtectSettings_over_freq_2: 'Grid Over Freq II',
          gridProtectSettings_under_freq_time_1: 'Grid Under Freq Time I',
          gridProtectSettings_under_freq_time_2: 'Grid Under Freq Time II',
          gridProtectSettings_over_freq_time_1: 'Grid Over Freq Time I',
          gridProtectSettings_over_freq_time_2: 'Grid Over Freq Time II',
          gridProtectSettings_under_freq_protect: 'Grid Under Freq Protect',
          gridProtectSettings_over_freq_protect: 'Grid Over Freq Protect',
          gridProtectSettings_insulation_threshold: 'Insulation Threshold',
          gridProtectSettings_pv_low_volt: 'PV Low Volt',
          gridProtectSettings_pv_start_volt: 'PV Start Volt',
          gridProtectSettings_pv_over_volt: 'PV Over Volt',
          gridProtectSettings_first_volt_lower_lmt: 'First Startup Grid Volt Lower Lmt',
          gridProtectSettings_first_volt_upper_lmt: 'First Startup Grid Volt Upper Lmt',
          gridProtectSettings_first_freq_lower_lmt: 'First Startup Grid Freq Lower Lmt',
          gridProtectSettings_first_freq_upper_lmt: 'First Startup Grid Freq Upper Lmt',
          lHVRTSettings: 'L/HVRT',
          lHVRTSettings_mode: 'L/HVRT Mode',
          lHFRTSettings: 'L/HFRT',
          lHFRTSettings_mode: 'L/HFRT Mode',
          pUSettings: 'P-U',
          pUSettings_mode: 'P-U Mode',
          pFSettings: 'P-F',
          pFSettings_mode: 'P-F Mode',
          qUSettings: 'Q-U',
          qUSettings_mode: 'Q-U Mode',
          sPFSettings: 'SPF',
          sPFSettings_mode: 'SPF Mode',
          parallelSettingSettings: 'Parallel Setting',
          parallelSettingSettings_type: 'Parallel Type',
          parallelSettingSettings_number: 'Parallel Number',
          parallelSettingSettings_address: 'Parallel Address',
          parallelSettingSettings_shared_battery: 'Shared Battery',
          parallelSettingSettings_combined_three_phase: 'Combined Three Phase',
          parallelSettingSettings_local_phase: 'Local Phase'
        }
      },
      switchbox: {
        title: 'Switchbox Settings',
        operation_model: 'Operation Model',
        grid_connection_control: 'GridConnection Control',
        smartload_control: 'Smartload Control',
        utility_plan: 'Utility Plan',
        electricity_rate: 'Electricity Rate'
      },
      v2g: {
        title: 'V2G Settings',
        chargeSettings: 'Immediate Charge',
        dischargeSettings: 'Immediate DisCharge',
        makeChargeSettings: 'Make Charge',
        makeDischargeSettings: 'Make DisCharge',
        dispatchSettings: 'Grid Dispatch',
        optimizeSettings: 'Elec. Optimization',
        chargeSettings_power: 'Limit Power',
        chargeSettings_soc: 'Limit SOC',
        chargeSettings_feedNetwork: 'Feed Network',
        dischargeSettings_power: 'Limit Power',
        dischargeSettings_soc: 'Limit SOC',
        dischargeSettings_feedNetwork: 'Feed Network',
        makeChargeSettings_status: 'Make Charge',
        makeChargeSettings_power: 'Limit Power',
        makeChargeSettings_soc: 'Limit SOC',
        makeChargeSettings_feedNetwork: 'Feed Network',
        makeDischargeSettings_status: 'Make DisCharge',
        makeDischargeSettings_power: 'Limit Power',
        makeDischargeSettings_soc: 'Limit SOC',
        makeDischargeSettings_feedNetwork: 'Feed Network',
        dispatchSettings_status: 'Grid Dispatch',
        dispatchSettings_time: 'Dispatch Time',
        dispatchSettings_feedNetwork: 'Feed Network',
        optimizeSettings_status: 'Elec. Optimization',
        optimizeSettings_power: 'Limit Power',
        optimizeSettings_soc: 'Limit SOC',
        optimizeSettings_feedNetwork: 'Feed Network',
        grt_chargeCurrLimit: 'Charge Current',
        grt_switchOverCurrAlarm1: 'Level 1 overcurrent alarm',
        grt_overCurrAlarm1: 'First level overcurrent threshold',
        grt_switchOverVoltAlarm: 'Overvoltage alarm',
        grt_overVoltAlarm: 'Overvoltage threshold',
        grt_switchUnderVoltAlarm: 'Under voltage alarm',
        grt_underVoltAlarm: 'Under voltage threshold',
        grt_switchContactorCopy: 'Contactor adhesion',
        grt_switchEarthFault: 'Grounding fault',
        grt_switchUrgencyStopFault: 'Emergency stop malfunction',
        grt_switchCpExpFault: 'CPCP abnormal fault',
        grt_switchMeterCmnFault: 'meter communication failure',
        grt_switchCardReaderFault: 'Card reader malfunction',
        grt_switchLeakFault: 'Leakage fault',
        off_grid_title: 'Off-Grid',
        off_grid_discharge: 'Electro-Discharge',
        off_grid_soc: 'Limit SOC',
        makeTimeSettings: 'Reservation of charging and discharging time settings',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        time_charge: 'Charge',
        time_discharge: 'DisCharge',
        time_separator: 'To',
        time_start: 'Starting time',
        time_end: 'End time',
        time_repeated: 'Repeated time periods',
        empty: 'The week or time period cannot be empty'
      },
      charge: {
        title: 'EV Charging Station Settings'
      }
    },
    madeAll: {
      inverter: {
        select: {
          title: 'Inverter Selection',
          station: {
            name: 'Station Name',
            username: 'End User',
            name_placeholder: 'Please enter the station name'
          },
          stationInverter: {
            sn: 'SN',
            name: 'Station Name',
            sn_placeholder: 'Please enter the sn'
          }
        }
      }
    },
    battereyState: {
      'none': '',
      '1': 'Normal',
      '2': 'Charging',
      '3': 'Discharge',
      '4': 'Fault'
    },
    battereyStatus: {
      'none': '',
      '0': 'Offline',
      '1': 'Online',
      '2': 'Alarm',
      '3': 'Unregistered',
      '4': 'Fault'
    },
    runStatus: {
      'none': '',
      '0': 'Offline',
      '1': 'Online',
      '2': 'Alarm',
      '3': 'Unregistered',
      '4': 'Fault'
    },
    deviceStatus: {
      'none': '',
      '0': 'Offline',
      '1': 'Online',
      '2': 'Alarm',
      '3': 'Unregistered',
      '4': 'Fault'
    },
    deviceLetterStatus: {
      'none': '',
      'offline': 'Offline',
      'normal': 'Online',
      'warning': 'Alarm',
      'fault': 'Fault'
    },
    deviceActiveBind: {
      'none': '',
      '0': 'No',
      '1': 'Yes'
    },
    lostStatus: {
      'none': '',
      '0': 'Offline',
      '1': 'Online'
    },
    bmsForceCharge: {
      'none': '',
      '0': 'Allowed',
      '1': 'Prohibit'
    }
  },

  main: {
    upgrade: {
      params:{
        title: 'Params Table Management',
        name: 'Name',
        name_empty: 'Please enter params table name',
        name_placeholder: 'Please enter params table name',
        productId: 'Product',
        productId_empty: 'Please select the product',
        productId_placeholder: 'Please select the product',
        deviceType: 'DeviceType',
        deviceType_empty: 'Please select device type',
        deviceType_placeholder: 'Please select device type',
        newVersion: 'Latest Version',
        version: 'Version',
        version_placeholder: 'Please enter the version',
        fileName: 'FileName',
        remark: 'Description',
        remark_placeholder: 'Enter description',
        uploadTime: 'Upload Time',
        size: 'Size',
        detailName: 'Params',
        add: {
          title: ' Params Table',
          btn: 'Create Params Table'
        },
        detail: {
          title: 'Params Table Details',
          upload: 'Upload'
        }
      },
      firmware: {
        title: 'Firmware Management',
        name: 'Name',
        name_empty: 'Please enter firmware name',
        name_placeholder: 'Enter firmware name',
        deviceType: 'Device Type',
        eviceType_empty: 'Please select device type',
        deviceType_placeholder: 'Select device type',
        firmwareType: 'Firmware Type',
        firmwareType_empty: 'Please select firmware type',
        firmwareType_placeholder: 'Select firmware type',
        newVersion: 'Latest Version',
        version: 'Version',
        version_placeholder: 'Enter version',
        remark: 'Description',
        remark_placeholder: 'Enter description',
        uploadTime: 'Upload Time',
        size: 'Size',
        add: {
          title: 'Add Firmware',
          btn: 'Create Firmware'
        },
        detail: {
          title: 'Firmware Details',
          upload: 'Upload Firmware'
        }
      },
      upgrade: {
        title: 'Device Upgrade',
        name: 'Name',
        name_empty: 'Please enter task name',
        name_placeholder: 'Enter task name',
        firmwareName: 'Firmware Name',
        source: 'Source',
        source_empty: 'Please select the upgrade source',
        source_placeholder: 'Please select the upgrade source',
        deviceType: 'Device Type',
        deviceType_placeholder: 'Select device Type',
        productId: 'Product',
        productId_placeholder: 'Please select the product',
        type: 'Specify Type',
        type_placeholder: 'Select specify type',
        typeList: {
          all: 'All',
          deviceId: 'Specify Device SN',
          version: 'Specify Current Version',
          country: 'Specify Country',
          dealer: 'Specify Dealer',
          batch: 'Specify Batch Code'
        },
        table_select: 'Please select list',
        value: 'Type Content',
        value_placeholder: 'Please enter the specified type of content, Multiple separated by English commas',
        value_empty: 'Please enter the specified type of content',
        sn: 'SN',
        newVersion: 'New Version',
        oldVersion: 'Old Version',
        startTime: 'Start Time',
        endTime: 'End Time',
        longTime: 'Duration',
        progress: 'Upgrade Progress',
        uploadTime: 'Upgrade Time',
        uploadTime_range: 'To',
        uploadTime_start: 'Start Time',
        uploadTime_end: 'End Time',
        stop: 'Stop',
        status: {
          '0': 'Idle',
          '1': 'Start Downloading',
          '2': 'Download Successful',
          '3': 'Download Failed',
          '4': 'Start Upgrading',
          '5':' Upgrade Successful ',
          '6': 'Upgrade Failed'
        },
        add: {
          title: 'Create Upgrade Task',
          btn: 'Create Task',
          params: 'Params',
          firmware: 'Firmware',
          table: {
            sn: 'SN',
            version: 'Version',
            country: 'Country',
            owner: 'Owner',
            dealer: 'Dealer',
            installer: 'Installer'
          }
        }
      }
    },
    log: {
      warn: {
        title: 'Warning Log',
        count: {
          now: 'Current Device Warns',
          switchbox: 'Unrecover Switchbox',
          inverter: 'Unrecover Inverter',
          collector: 'Unrecover Collector',
          battery: 'Unrecover Battery',
          solar: 'Unrecover Solar',
          v2g: 'Unrecover V2G',
          charge: 'Unrecover Charge'
        },
        table: {
          name: 'Device ID',
          code: 'Code',
          grade: 'Level',
          info: 'Information',
          time: 'Report Time',
          serial: 'SN',
          reason: 'Reason',
          advise: 'Advice',
          handle: 'Handler',
          handleTime: 'Handle Time',
          handleRemark: 'Handle Remark',
          device: 'Device'
        },
        where: {
          name: 'Warning Name',
          name_placeholder: 'Enter warning name',
          code: 'Warning Code',
          code_placeholder: 'Enter warning code',
          deviceName: 'Device ID',
          deviceName_placeholder: 'Enter Device ID',
          sn: 'SN',
          sn_placeholder: 'Enter SN',
          deviceType: 'Device Type',
          deviceType_placeholder: 'Select device type',
          time: 'Report Time',
          time_range: 'To',
          time_start: 'Start Time',
          time_end: 'End Time'
        }
      },
      device: {
        title: 'Device Log',
        isDeal_0: 'UnProcessed',
        isDeal_1: 'Processed',
        table: {
          deviceType: 'Device Type',
          state: 'Status',
          owner: 'Owner',
          station: 'Power Station',
          country: 'Country',
          address: 'Address',
          deviceId: 'Device ID',
          time: 'Report Time',
          sn: 'SN'
        },
        where: {
          sn: 'SN',
          sn_placeholder: 'Enter device SN',
          deviceId: 'DeviceID',
          deviceId_placeholder: 'Enter device ID',
          deviceType: 'DeviceType',
          deviceType_placeholder: 'Select device type',
          stationName: 'PowerStation',
          stationName_placeholder: 'Enter power station',
          ownerName: 'Owner',
          ownerName_placeholder: 'Enter owner',
          time: 'ReportTime',
          time_range: 'To',
          time_start: 'Start Time',
          time_end: 'End Time'
        }
      },
      operate: {
        title: 'Operation Log',
        table: {
          types: 'Log Types',
          description: 'Describe',
          name: 'Username',
          content: 'Content',
          time: 'Operation Time',
          deviceType: 'Device',
          ip: 'IP Address',
          remark: 'Remark',
          result: 'Result',
          osName: 'System',
          osVersion: 'Version',
          sn: 'SN',
          module: 'Module',
          role: 'Role',
          receiveTime: 'Receive Time'
        },
        where: {
          sn: 'SN',
          sn_placeholder: 'Enter SN',
          name: 'UserName',
          name_placeholder: 'Enter username',
          roleId: 'Role',
          roleId_placeholder: 'Select role',
          time: 'ActionTime',
          time_range: 'To',
          time_start: 'Start Time',
          time_end: 'End Time'
        }
      }
    },
    file: {
      fileName: 'File Name',
      fileSize: 'Size',
      version: 'Version',
      createTime: 'Create Time',
      createUser: 'Creator',
      updateTime: 'Modify Time',
      updateUser: 'Modifier',
      fileName_placeholder: 'Please enter the file name',
      download: 'Download',
      upload: 'Upload',
      uploading: 'Uploading...',
      upload_success: 'Upload successful',
      upload_error: 'Upload failed',
      delete_confirm: 'Are you sure to delete this file?',
      title: 'File Classification',
      add: 'Add Category',
      zhName: 'Chinese Name',
      zhName_empty: 'Please enter a Chinese name',
      enName: 'English Name',
      enName_empty: 'Please enter an English name',
      addSub: 'Add Subcategory',
      edit: 'Edit Category',
      delete: 'Delete Category',
      treeDelete_confirm: 'Are you sure to delete this category?'
    },
    analysis: {
      content: 'Data',
      content_placeholder: 'Please enter parsed data',
      type: 'Type',
      type_placeholder: 'Please select data type',
      submit: 'Start Parse',
      submiting: 'parsing...'
    }
  },

  question: {
    base: {
      dic: 'Double click on the list to edit the dictionary',
      menu: 'Double click on the list to edit the menu',
      role: 'Double click on the list to edit the role',
      user: 'Double click on the list to view the user company information',
      warn: 'Double click on the list to edit alarms',
      company: 'Double click on the list to view the company user information',
      product: 'Double click on the list to edit products'
    },
    guide: {
      station: 'Click on the list to quickly preview the overview information of the power plant on the upper side, and double-click to enter the details of the power plant',
      device: 'Double click on the list to quickly access device details'
    },
    device: {
      v2g: 'Click on the list to quickly preview V2G overview information on the upper side, double-click to enter V2G details',
      switchbox: 'Click on the list to quickly preview switchbox overview information on the upper side, double-click to enter switchbox details',
      battery: 'Click on the list to quickly preview battery overview information on the upper side, double-click to enter battery details',
      charge: 'Click on the list to quickly preview the overview information of the charging station on the upper side, and double-click to enter the details of the charging station',
      collector: 'Click on the list to quickly preview the collector overview information on the upper side, double-click to enter collector details',
      inverter: 'Click on the list to quickly preview the overview information of the inverter on the upper side, double-click to enter the inverter details',
      solar: 'Click on the list to quickly preview the overview information of solar panels on the upper side, and double-click to enter the details of solar panels'
    },
    upgrade: {
      params: 'Double click on the list to open the parameter table details',
      firmware: 'Double click on the list to open firmware details'
    },
    log: {
      warn: 'Double click on the list to open the operation suggestion details',
      operate: 'Double click on the list to open log content details'
    }
  }
}
